<template>
  <v-container fluid style="max-width: 1440px;">
    <v-layout alig-start>
      <v-flex>
        <!-- Modal Escaner código de barra -->
        <v-dialog v-model="dialogCamara" max-width="400" persistent>
          <v-card>
            <v-toolbar dense flat color="primary" dark>
              <v-toolbar-title>Escanear Código</v-toolbar-title>
              <v-spacer />
              <v-btn icon @click="detenerEscaneo"><v-icon>close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text class="pa-2">
              <video ref="video" autoplay muted playsinline
                style="width: 100%; height: auto; object-fit: cover; border-radius: 8px;" />
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- Fin Modal escaner código de barra -->

        <!-- Inicio de barra de alerta -->
        <v-snackbar v-model="alerta.snackbar" :color="alerta.color" @click="alerta.snackbar = false" right>{{
          alerta.text }}</v-snackbar>
        <!-- Fin inicio de barra de alerta -->

        <!-- Listado de bienes y opciones de titulo, busqueda, nuevo, etc -->
        <v-data-table :loading="loading" :headers="cabBienes" :items="bienes" :items-per-page="15" disable-pagination
          hide-default-footer class="elevation-3" dense>
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title class="hidden-sm-and-down">BIENES ACTIVOS</v-toolbar-title>
              <v-divider class="mx-2 hidden-sm-and-down" inset vertical></v-divider>
              <!-- Impresion bien -->
              <!-- <v-btn fab x-small color="info" @click="crearPDF()" class="mr-1">
              <v-icon>print</v-icon>
              </v-btn>-->
              <!-- Fin impresion bien -->
              <v-spacer />

              <!-- Formulario busqueda de bien -->
              <v-text-field class="hidden-sm-and-down" v-model.trim="buscar" @keyup="listar()" maxlength="40"
                prepend-inner-icon="search" v-uppercase dense label="Búsqueda" hide-details></v-text-field>
              <v-text-field class="hidden-sm-and-down shrink" v-model.trim="correlative" @keyup="listar()" maxlength="4"
                v-uppercase dense label="Correlativo" hide-details></v-text-field>
              <v-spacer />

              <v-text-field dense autofocus class="mr-2" v-model.trim="codigo_barra" prepend-icon="barcode_reader"
                @click:prepend="iniciarEscaneo" label="Código de Barra" @keyup.enter="buscarCodigoBarra()"
                :rules="[v => !!v || 'requerido', v => (!!v && v.length >= 8) || 'requerido']" maxlength="15"
                hide-details clearable></v-text-field>
              <!-- <v-btn
              x-small
              fab
              color="info"
              @click="buscarCodigoBarra()"
              class="hidden-sm-and-down"
            >
              <v-icon>search</v-icon>
              </v-btn>-->
              <v-spacer />
              <!-- Fin Formulario Busqueda de bien -->

              <!-- Modal crear y modificar bien -->
              <v-dialog v-model="dialog" max-width="1000px" persistent>
                <template v-slot:activator="{ on }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn fab x-small dark class="ml-2" color="internal" v-on="on"
                        @click="dialog = true, codcondicion = 'Interno'">
                        <v-icon dark>add</v-icon>
                      </v-btn>
                    </template>
                    <span>Nuevo Bien Interno</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn fab x-small dark class="ml-2" color="primary" v-on="on"
                        @click="dialog = true, codcondicion = 'Patrimonial'">
                        <v-icon dark>add</v-icon>
                      </v-btn>
                    </template>
                    <span>Nuevo Bien Patrimonial</span>
                  </v-tooltip>
                </template>
                <v-card>
                  <v-toolbar dark dense :class="(codcondicion === 'Interno' ? 'internal' : 'primary')">
                    <v-toolbar-title>{{ formTitle + " " + codcondicion }}</v-toolbar-title>
                    <v-spacer />
                    <template v-if='codbien.length == 12'>
                      <strong>{{ codbien }} </strong>
                    </template>
                    <template v-else-if="codbien.length == 8">
                      <strong>{{ codbienint + "-" + codinterno }}</strong>
                    </template>

                    <v-spacer />
                    <v-btn icon dark @click="guardar" :loading="desabilitar" :disabled="desabilitar || !isValid">
                      <v-icon>save</v-icon>
                    </v-btn>
                    <v-btn icon dark @click="close">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-form v-model="isValid">
                      <v-container>
                        <v-row justify="end" v-if="codcondicion == 'Interno', codbien.length == 8">
                          <v-switch v-model="gencodpatrimonial" hide-details
                            :label="`Generar Código Patrimonial: ${gencodpatrimonial == true ? 'SI' : 'NO'}`"></v-switch>
                        </v-row>
                        <v-toolbar-title class="mb-3 primary--text">Datos del Bien
                          <v-list-item-subtitle v-if="codtipobien != null && codtipobien != ''" class="info--text">Grupo
                            Genérico: {{ grupo }} Clase: {{ clase }}</v-list-item-subtitle>
                        </v-toolbar-title>
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-autocomplete dense @keyup="selectTbien()" :search-input.sync="buscar_tipobien"
                              v-model.trim="codtipobien" :items="selectTipobienArray" label="Selecciona Tipo Bien"
                              :rules="[v => !!v || 'Requerido']" :disabled="disabledcodtipobien"
                              @change="mostrarGrupoClase(), selectGrupoClase()" clearable hide-details></v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="12">
                            <v-autocomplete dense @keyup="selectAsignacion()" :search-input.sync="buscar_personal"
                              v-model.trim="idasignacion" :items="selectAsignacionArray"
                              label="Selecciona: Personal | Local > Area - Oficina" :rules="[v => !!v || 'Requerido']"
                              clearable hide-details></v-autocomplete>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-select dense :items="cm.tipo_ctas" v-model="tipo_cta" label="Tipo de Cuenta"
                              :rules="[v => !!v || 'Requerido']" @change="selectCuentascArray = [], selectCcontable()"
                              required hide-details :disabled="modificarBien"></v-select>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-select dense v-model.trim="cuenta" :items="selectCuentascArray"
                              label="Selecciona Cuenta Contable" :rules="[v => !!v || 'Requerido']"
                              :disabled="tipo_cta == '' ? true : false || modificarBien" hide-details></v-select>
                          </v-col>
                          <v-col cols="6" sm="3">
                            <v-select dense :items="cm.flg_conds" v-model="flg_cond" label="Forma de Adquisición"
                              :rules="[v => !!v || 'Requerido']" required hide-details :disabled="modificarBien">
                            </v-select>
                          </v-col>
                          <v-col cols="6" sm="2">
                            <v-menu v-model="menuFechaRegistro" :close-on-content-click="false" :nudge-right="40"
                              transition="scale-transition" offset-y min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field dense v-model="fecha_registro_formateado" label="Fecha Adquisición"
                                  :rules="[v => !!v || 'Fecha Requerido']" readonly v-on="on" hide-details
                                  :disabled="modificarBien"></v-text-field>
                              </template>
                              <v-date-picker v-model="fec_reg" @input="menuFechaRegistro = false"
                                @change="fechaRegistroSeleccionada(fec_reg)"></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" sm="4">
                            <v-text-field dense v-model.trim="doc_alta" label="Doc. Alta" maxlength="25" v-uppercase
                              hide-details :disabled="modificarBien"></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="2">
                            <v-text-field dense v-mask-decimal.us="2" v-model.trim="valordq" label="Valor Adquisición"
                              maxlength="13" v-uppercase hide-details :disabled="modificarBien"></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="2">
                            <v-text-field dense v-mask-decimal.us="2" v-model.trim="valorlibro" label="Valor Neto"
                              maxlength="13" v-uppercase hide-details :disabled="modificarBien"></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="2">
                            <v-select dense :items="cm.flg_estados" v-model="flg_estado" label="Estado del Bien"
                              :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-select dense :items="cm.flg_asegurados" v-model="asegurado" label="Asegurado"
                              :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                          </v-col>
                          <v-col cols="12" sm="3">
                            <v-select dense :items="cm.flg_situaciones" v-model="situacion" label="Situación"
                              :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                          </v-col>
                          <v-col cols="6" sm="4">
                            <v-text-field dense v-model.trim="clasif_presup_gasto"
                              label="Clasificador Presupuestal de Gasto" maxlength="40" hide-details></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-container>
                        <v-toolbar-title class="mb-3 primary--text">Detalle Técnico</v-toolbar-title>
                        <v-row>
                          <v-col cols="6" sm="3">
                            <v-text-field dense v-model.trim="marca" label="Marca" maxlength="100" v-uppercase
                              hide-details></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="3">
                            <v-text-field dense v-model.trim="modelo" label="Modelo" maxlength="50" v-uppercase
                              hide-details></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="2">
                            <v-text-field dense v-model.trim="tipo" label="Tipo" maxlength="50" v-uppercase
                              hide-details></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="2">
                            <v-text-field dense v-model.trim="color" label="Color" maxlength="15" v-uppercase
                              hide-details></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="2">
                            <v-text-field dense v-model.trim="serie" label="Serie" maxlength="25" v-uppercase
                              hide-details></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="2">
                            <v-text-field dense v-model.trim="dimension" label="Dimensión m*a*h" maxlength="25"
                              v-uppercase hide-details></v-text-field>
                          </v-col>
                          <!-- NO VISUALIZAMOS SI PERTENENCE A LA CLASE 82=vehiculos,04=aeronaves,36=Maquinaria pesada -->
                          <template
                            v-if="codtipobien == null ? false : (codtipobien.substring(2, 4) == '82') ? true : (codtipobien.substring(2, 4) == '04') ? true : (codtipobien.substring(2, 4) == '36')">
                            <v-col cols="6" sm="2">
                              <v-text-field dense v-model.trim="placa" label="Placa" maxlength="20" v-uppercase
                                hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="2">
                              <v-text-field dense v-model.trim="ano" label="Año" maxlength="4" v-mask-number
                                hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="3">
                              <v-text-field dense v-model.trim="nummotor" label="Nº Motor" maxlength="20" v-uppercase
                                hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="3">
                              <v-text-field dense v-model.trim="numchasis" label="Nº Chasis" maxlength="20" v-uppercase
                                hide-details></v-text-field>
                            </v-col>

                            <v-col cols="6" sm="3">
                              <v-text-field dense v-model.trim="carroceria" label="Carroceria" maxlength="30"
                                v-uppercase hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="3">
                              <v-text-field dense v-model.trim="nro_ejes" label="Nº Ejes" maxlength="10" v-uppercase
                                hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="3">
                              <v-text-field dense v-model.trim="combustible" label="Combustible" maxlength="20"
                                v-uppercase hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="3">
                              <v-text-field dense v-model.trim="transmision" label="Transmisión" maxlength="20"
                                v-uppercase hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="3">
                              <v-text-field dense v-model.trim="cilindrada" label="Cilindrada" maxlength="20"
                                v-uppercase hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="3">
                              <v-text-field dense v-model.trim="kilometraje" label="Kilometraje" maxlength="20"
                                v-uppercase hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="3">
                              <v-text-field dense v-model.trim="tarjeta_propiedad" label="Tarjeta Propiedad"
                                maxlength="30" v-uppercase hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="3" v-if="editedIndex > -1">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-btn fab x-small dark class="ml-2" color="info" v-on="on"
                                    @click="editarDetalleVehiculo(idbien)">
                                    <v-icon dark>list</v-icon>
                                  </v-btn>
                                </template>
                                <span>Apreciación Técnica</span>
                              </v-tooltip>
                            </v-col>
                          </template>

                          <v-col cols="12">
                            <v-textarea dense rows="1" v-model.trim="otras_caract" label="Otras Caracteristicas"
                              maxlength="254" v-uppercase hide-details></v-textarea>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea dense rows="2" v-model.trim="observacion" label="Observación" maxlength="254"
                              v-uppercase hide-details></v-textarea>
                          </v-col>
                          <!-- Mensaje error bien -->
                          <v-col cols="12" v-if="mensajeBien != ''">
                            <v-alert text dense type="error">{{ mensajeBien }}</v-alert>
                          </v-col>
                          <!-- Mensaje error bien -->

                          <!-- Imagen -->
                          <v-col cols="12" sm="4" align="center">
                            <template v-if="imagen == '' || imagen == null">
                              <v-avatar tile size="250">
                                <img :src="'data:image/png;base64,' + imagenxdefec" @click="$refs.boton.click()" />
                              </v-avatar>
                            </template>
                            <template color="teal" v-else>
                              <v-avatar tile size="250">
                                <img :src="'data:image/png;base64,' + imagen" @click="$refs.boton.click()" />
                              </v-avatar>
                            </template>
                            <input type="file" id="file" ref="boton" accept=".png, .jpg, .jpeg"
                              @change="buscarImagen($event)" class="d-none" />
                          </v-col>

                          <!-- Imagen 2 -->
                          <v-col cols="12" sm="4" align="center">
                            <template v-if="imagen2 == '' || imagen2 == null">
                              <v-avatar tile size="250">
                                <img :src="'data:image/png;base64,' + imagenxdefec" @click="$refs.boton2.click()" />
                              </v-avatar>
                            </template>
                            <template v-else>
                              <v-avatar tile size="250">
                                <img :src="'data:image/png;base64,' + imagen2" @click="$refs.boton2.click()" />
                              </v-avatar>
                            </template>
                            <input type="file" id="file2" ref="boton2" accept=".png, .jpg, .jpeg"
                              @change="buscarImagen2($event)" class="d-none" />
                          </v-col>

                          <!-- Imagen 3 -->
                          <v-col cols="12" sm="4" align="center">
                            <template v-if="imagen3 == '' || imagen3 == null">
                              <v-avatar tile size="250">
                                <img :src="'data:image/png;base64,' + imagenxdefec" @click="$refs.boton3.click()" />
                              </v-avatar>
                            </template>
                            <template v-else>
                              <v-avatar tile size="250">
                                <img :src="'data:image/png;base64,' + imagen3" @click="$refs.boton3.click()" />
                              </v-avatar>
                            </template>
                            <input type="file" id="file3" ref="boton3" accept=".png, .jpg, .jpeg"
                              @change="buscarImagen3($event)" class="d-none" />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-dialog>
              <!-- Fin Modal crear y modificar bien -->
            </v-toolbar>
          </template>
          <!-- Opciones editar, eliminar bien -->
          <template v-slot:item.codbien="{ item }">
            <template v-if="item.codbien && item.codbien.length == 12">
              <v-badge v-if="item.codinterno" :content="item.codinterno" color="internal" overlap offset-x="10"
                offset-y="10">
                <v-chip label color="primary">
                  <span style="padding: 0; margin: 0;">
                    {{ item.codbien.substr(0, 8) }}<strong :class="{ 'error--text': item.situacion === 'F' }">{{
                      item.codbien.slice(8) }}</strong>
                  </span>
                </v-chip>
              </v-badge>
              <v-chip v-else label color="primary">
                <span style="padding: 0; margin: 0;">
                  {{ item.codbien.substr(0, 8) }}<strong :class="{ 'error--text': item.situacion === 'F' }">{{
                    item.codbien.slice(8) }}</strong>
                </span>
              </v-chip>
            </template>
            <template v-else-if="item.codbien.length == 8">
              <v-chip label color="internal" text-color="white">
                <span>{{ item.codbienint + "-" + item.codinterno }}</span>
              </v-chip>
            </template>
            <!-- <template v-if='item.codbien.length == 12'>
              <v-chip small label color="primary">
                <span style="padding: 0; margin: 0;">
                  {{ item.codbien.substr(0, 8) }}<strong>{{ item.codbien.substr(8, 12) }}</strong>
                </span>
              </v-chip>
            </template>
            <template v-else-if="item.codbien.length == 8">
              <v-chip small label color="internal" text-color="white">
                <span>{{ item.codbienint + "-" + item.codinterno }}</span>
              </v-chip>
            </template> -->
          </template>
          <template v-slot:item.tbdescripcion="{ item }">
            <div class="text-caption">
              <strong>{{ item.tbdescripcion }}</strong>
            </div>
          </template>

          <template v-slot:item.ubicacion="{ item }">
            <div class="text-caption">
              <v-icon x-small color="info">location_city</v-icon>
              {{ item.nomlocales }}
            </div>
            <div class="ml-1 text-caption">
              <v-icon x-small color="info">hub</v-icon>
              {{ item.nomareas }}
            </div>
            <div class="ml-2 text-caption">
              <v-icon x-small color="info">meeting_room</v-icon>
              <strong> {{ item.nomoficinas }}</strong>
            </div>
            <div class="ml-3 text-caption font-weight-medium">
              <v-icon x-small color="internal">face</v-icon>
              <strong> {{ item.pnombres }}</strong>
            </div>
          </template>

          <template v-slot:item.actividad="{ item }">
            <div class="text-caption font-weight-medium">
              <v-icon x-small color="internal">person</v-icon>
              {{ item.nickname }}
            </div>
            <div class="text-caption">
              <v-icon x-small color="primary">schedule</v-icon>
              {{ item.fec_act | formatearFechaHora }}
            </div>
          </template>

          <template v-slot:item.opciones="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn x-small icon v-bind="attrs" v-on="on">
                  <v-icon color="accent" @click="mostrarBienImp(item)">description</v-icon>
                </v-btn>
              </template>
              <span>Ficha Bien Patrimonial</span>
            </v-tooltip>

            <template v-if="item.iddetalle_vehiculo">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn x-small icon v-bind="attrs" v-on="on">
                    <v-icon color="info" @click="mostrarBienVehImp(item)">menu_book</v-icon>
                  </v-btn>
                </template>
                <span>Ficha Vehículo</span>
              </v-tooltip>
            </template>

            <template v-if="item.seguimiento == true">
              <template v-if="esSuperadministrador || esAdministrador || esSupervisor">
                <!-- <v-btn x-small icon>
                  <v-icon color="success" @click="activarMostrar(1, item)">verified</v-icon>
                </v-btn> -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn x-small icon v-bind="attrs" v-on="on">
                      <v-icon color="success" @click="activarMostrar(1, item)">verified</v-icon>
                    </v-btn>
                  </template>
                  <span>Verificado</span>
                </v-tooltip>
              </template>
              <template v-else>
                <!-- <v-btn x-small icon>
                  <v-icon color="success">verified</v-icon>
                </v-btn> -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn x-small icon v-bind="attrs" v-on="on">
                      <v-icon color="success">verified</v-icon>
                    </v-btn>
                  </template>
                  <span>Verificado</span>
                </v-tooltip>

              </template>
            </template>
            <template v-else>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn x-small icon v-bind="attrs" v-on="on">
                    <v-icon :color="item.codbien.length == 12 ? 'primary' : 'internal'"
                      @click="editBienItem(item, 'e')">edit</v-icon>
                  </v-btn>
                </template>
                <span>Modificar Bien</span>
              </v-tooltip>
            </template>
            <template v-if="(esSuperadministrador || esAdministrador || esSupervisor) & item.eliminar == 'S'">
              <v-btn x-small icon>
                <v-icon color="error" @click="deleteItem(item)">delete_forever</v-icon>
              </v-btn>
            </template>

            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn x-small icon>
                  <v-icon v-on="on" color="secondary">more_vert</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item link>
                  <v-list-item-content @click="editBienItem(item, 'd')">
                    <v-list-item-title>Duplicar Bien</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-icon>
                    <v-icon x-small :color="item.codbien.length == 12 ? 'primary' : 'internal'">file_copy</v-icon>
                  </v-list-item-icon>
                </v-list-item>

                <v-list-item link>
                  <v-list-item-content @click="crearXlsxDepreciacion(item)">
                    <v-list-item-title>Cuadro Depreciación</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-icon>
                    <v-icon x-small color="success">summarize</v-icon>
                  </v-list-item-icon>
                </v-list-item>

                <template v-if="(esSuperadministrador || esAdministrador || esSupervisor) && item.codbien.length == 12">
                  <v-list-item link>
                    <v-list-item-content @click="bajaBienItem(item)">
                      <v-list-item-title>Baja de Bien</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-icon x-small color="warning">do_disturb</v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                </template>
              </v-list>
            </v-menu>

          </template>
          <!-- Fin Opciones editar, eliminar bien -->
        </v-data-table>
        <!-- Fin Listado de bienes y opciones de titulo, busqueda, nuevo, etc -->

        <!-- Modal Reestablecer seguimiento -->
        <v-dialog v-model="adModal" max-width="380">
          <v-card>
            <v-card-title class="headline justify-center" v-if="adAccion == 1">¿Reestablecer?</v-card-title>
            <v-card-text>
              Estás a punto de
              <span v-if="adAccion == 1">reestablecer seguimiento</span>
              del bien: {{ adId }}
            </v-card-text>
            <v-card-actions class="py-0 pb-4 justify-center">
              <v-btn text x-small color="error" @click="activarDesactivarCerrar()">Cancelar</v-btn>
              <v-btn v-if="adAccion == 1" text x-small color="success" @click="activar()">Reestablecer</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Fin Modal Reestablecer seguimiento -->

        <!-- Mostrar impresion Modal bien -->
        <v-dialog v-model="verBienModalImp" max-width="980px" scrollable>
          <v-card>
            <v-toolbar dark dense class="primary">
              <v-toolbar-title>Bien Patrimonial</v-toolbar-title>
              <v-spacer />
              <template v-if='codbien.length == 12'>
                <strong>{{ codbien }} </strong>
              </template>
              <template v-else-if="codbien.length == 8">
                <strong>{{ codbienint + "-" + codinterno }}</strong>
              </template>

              <v-spacer />
              <v-btn icon dark class="hidden-sm-and-down" @click="printExternal()">
                <v-icon>print</v-icon>
              </v-btn>
              <v-btn icon dark @click="savePdf()">
                <v-icon>download</v-icon>
              </v-btn>
              <v-btn icon dark @click="ocultarBienImp()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text style="height: 520px;" class="px-0">
              <pdf v-for="i in numPages" :key="i" :src="srcPdf" :page="i"></pdf>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- Fin Mostrar impresion Modal bien -->

        <!-- Mostrar Modal baja bien -->
        <v-dialog v-model="verBajaBienModal" max-width="980px" persistent>
          <v-card>
            <v-toolbar dark dense class="warning">
              <v-toolbar-title>Baja de Bien</v-toolbar-title>
              <v-spacer />
              <span>{{ codbien }}</span>
              <v-spacer />
              <v-btn icon dark @click="guardarBaja" :loading="desabilitar" :disabled="desabilitar || !isValid">
                <v-icon>save</v-icon>
              </v-btn>

              <v-btn icon dark @click="ocultarBajaBien()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-form v-model="isValid">
                <v-container>
                  <v-toolbar-title class="mb-3 primary--text">
                    Datos del Bien
                    <v-list-item-subtitle v-if="codtipobien != null && codtipobien != ''" class="info--text">Grupo
                      Genérico: {{ grupo }} Clase: {{ clase }}</v-list-item-subtitle>
                  </v-toolbar-title>
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-autocomplete dense @keyup="selectTbien()" :search-input.sync="buscar_tipobien"
                        v-model.trim="codtipobien" :items="selectTipobienArray" label="Selecciona Tipo Bien"
                        :rules="[v => !!v || 'Requerido']" :disabled="disabledcodtipobien" @change="mostrarGrupoClase()"
                        clearable hide-details></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="12">
                      <v-autocomplete dense @keyup="selectAsignacion()" :search-input.sync="buscar_personal"
                        v-model.trim="idasignacion" :items="selectAsignacionArray"
                        label="Selecciona: Personal | Local > Area - Oficina" :rules="[v => !!v || 'Requerido']"
                        clearable hide-details></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-select dense :items="cm.tipo_ctas" v-model="tipo_cta" label="Tipo de Cuenta"
                        :rules="[v => !!v || 'Requerido']" @change="selectCuentascArray = [], selectCcontable()"
                        required hide-details></v-select>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-select dense v-model.trim="cuenta" :items="selectCuentascArray"
                        label="Selecciona Cuenta Contable" :rules="[v => !!v || 'Requerido']"
                        :disabled="tipo_cta == '' ? true : false" hide-details></v-select>
                    </v-col>
                    <v-col cols="6" sm="3">
                      <v-select dense :items="cm.flg_conds" v-model="flg_cond" label="Forma de Adq."
                        :rules="[v => !!v || 'Requerido']" required disabled hide-details></v-select>
                    </v-col>
                    <v-col cols="6" sm="2">
                      <v-menu v-model="menuFechaRegistro" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field dense v-model="fecha_registro_formateado" label="Fecha Adq."
                            :rules="[v => !!v || 'Fecha Requerido']" readonly v-on="on" disabled hide-details>
                          </v-text-field>
                        </template>
                        <v-date-picker v-model="fec_reg" @input="menuFechaRegistro = false"
                          @change="fechaRegistroSeleccionada(fec_reg)"></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field dense v-model.trim="doc_alta" label="Doc. Adq." maxlength="25" disabled v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="2">
                      <v-text-field dense v-mask-decimal.us="2" v-model.trim="valordq" label="Valor Adq." maxlength="13"
                        v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="2">
                      <v-text-field dense v-mask-decimal.us="2" v-model.trim="valorlibro" label="Valor Neto"
                        maxlength="13" v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="2">
                      <v-select dense :items="cm.flg_estados" v-model="flg_estado" label="Estado del Bien"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-select dense :items="cm.flg_asegurados" v-model="asegurado" label="Asegurado"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-select dense :items="cm.flg_situaciones" v-model="situacion" label="Situación"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                  </v-row>
                </v-container>

                <v-container>
                  <v-toolbar-title class="mb-3 warning--text">Acto de Baja</v-toolbar-title>
                  <v-row>
                    <v-col cols="6" sm="3">
                      <v-text-field dense v-model.trim="resol_baja" label="Resolución Baja" maxlength="25" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="2">
                      <v-menu v-model="menuFechaBaja" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field dense v-model="fecha_baja_formateado" label="Fecha"
                            :rules="[v => !!v || 'Fecha Requerido']" readonly v-on="on" hide-details></v-text-field>
                        </template>
                        <v-date-picker v-model="fec_baja" @input="menuFechaBaja = false"
                          @change="fechaBajaSeleccionada(fec_baja)"></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="6" sm="3">
                      <v-select dense :items="cm.flg_causales" v-model="flg_causal" label="Causal de Baja"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea dense rows="2" v-model.trim="observacion" label="Observación" maxlength="200"
                        v-uppercase hide-details></v-textarea>
                    </v-col>

                    <!-- Mensaje error bien -->
                    <v-col cols="12" v-if="mensajeBien != ''">
                      <v-alert text dense type="error">{{ mensajeBien }}</v-alert>
                    </v-col>
                    <!-- Mensaje error bien -->

                    <!-- Imagen -->
                    <v-col cols="12" sm="4" align="center">
                      <template v-if="imagen == '' || imagen == null">
                        <v-avatar tile size="250">
                          <img :src="'data:image/png;base64,' + imagenxdefec" @click="$refs.boton.click()" />
                        </v-avatar>
                      </template>
                      <template color="teal" v-else>
                        <v-avatar tile size="250">
                          <img :src="'data:image/png;base64,' + imagen" @click="$refs.boton.click()" />
                        </v-avatar>
                      </template>
                      <input type="file" id="file" ref="boton" accept=".png, .jpg, .jpeg" @change="buscarImagen($event)"
                        class="d-none" />
                    </v-col>

                    <!-- Imagen 2 -->
                    <v-col cols="12" sm="4" align="center">
                      <template v-if="imagen2 == '' || imagen2 == null">
                        <v-avatar tile size="250">
                          <img :src="'data:image/png;base64,' + imagenxdefec" @click="$refs.boton2.click()" />
                        </v-avatar>
                      </template>
                      <template v-else>
                        <v-avatar tile size="250">
                          <img :src="'data:image/png;base64,' + imagen2" @click="$refs.boton2.click()" />
                        </v-avatar>
                      </template>
                      <input type="file" id="file2" ref="boton2" accept=".png, .jpg, .jpeg"
                        @change="buscarImagen2($event)" class="d-none" />
                    </v-col>

                    <!-- Imagen 3 -->
                    <v-col cols="12" sm="4" align="center">
                      <template v-if="imagen3 == '' || imagen3 == null">
                        <v-avatar tile size="250">
                          <img :src="'data:image/png;base64,' + imagenxdefec" @click="$refs.boton3.click()" />
                        </v-avatar>
                      </template>
                      <template v-else>
                        <v-avatar tile size="250">
                          <img :src="'data:image/png;base64,' + imagen3" @click="$refs.boton3.click()" />
                        </v-avatar>
                      </template>
                      <input type="file" id="file3" ref="boton3" accept=".png, .jpg, .jpeg"
                        @change="buscarImagen3($event)" class="d-none" />
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- Fin Mostrar Modal baja bien -->

        <!-- Mostrar Modal detalle vehiculo -->
        <v-dialog v-model="verDetVehiculo" max-width="1000px" persistent>
          <v-card>
            <v-form v-model="isValid">
              <v-toolbar dark dense class="info">
                <v-toolbar-title>{{ formTitleDetVeh }} Apreciación Técnica</v-toolbar-title>
                <v-spacer />
                <v-btn icon dark @click="guardarDetVeh" :loading="desabilitarDetVeh"
                  :disabled="desabilitarDetVeh || !isValid">
                  <v-icon>save</v-icon>
                </v-btn>
                <v-btn icon dark @click="closeDetVehiculo">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container>
                  <v-toolbar-title class="mb-3 info--text">1. Sistema de Motor</v-toolbar-title>
                  <v-row>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="cilindro" label="Cilindros" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_cilindro" :rules="[v => !!v || 'Requerido']"
                        required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="carburador_carter" label="Carburador / Carter" maxlength="100"
                        v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_carburador_carter"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="distribuidor_bomba_inyeccion"
                        label="Distribuidor / Bomba de Inyección" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_distribuidor_bomba_inyeccion"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="bomba_gasolina" label="Bomba de Gasolina" maxlength="100"
                        v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_bomba_gasolina"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="purificador_aire" label="Purificador de Aire" maxlength="100"
                        v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_purificador_aire"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                  </v-row>
                </v-container>
                <v-container>
                  <v-toolbar-title class="mb-3 info--text">2. Sistema de Frenos</v-toolbar-title>
                  <v-row>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="bomba_freno" label="Bomba de Frenos" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_bomba_freno"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="zapata_tambor" label="Zapatas y Tambores" maxlength="100"
                        v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_zapata_tambor"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="disco_pastilla" label="Discos y Pastillas" maxlength="100"
                        v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_disco_pastilla"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                  </v-row>
                </v-container>
                <v-container>
                  <v-toolbar-title class="mb-3 info--text">3. Sistema de Refrigeración</v-toolbar-title>
                  <v-row>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="radiador" label="Radiador" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_radiador" :rules="[v => !!v || 'Requerido']"
                        required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="ventilador" label="Ventilador" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_ventilador" :rules="[v => !!v || 'Requerido']"
                        required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="bomba_agua" label="Bomba de Agua" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_bomba_agua" :rules="[v => !!v || 'Requerido']"
                        required hide-details></v-select>
                    </v-col>
                  </v-row>
                </v-container>
                <v-container>
                  <v-toolbar-title class="mb-3 info--text">4. Sistema Electrico</v-toolbar-title>
                  <v-row>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="motor_arranque" label="Motor de Arranque" maxlength="100"
                        v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_motor_arranque"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="bateria" label="Batería" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_bateria" :rules="[v => !!v || 'Requerido']"
                        required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="alternador" label="Alternador" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_alternador" :rules="[v => !!v || 'Requerido']"
                        required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="bobina" label="Bobina" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_bobina" :rules="[v => !!v || 'Requerido']"
                        required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="relay_alternador" label="Relay de Alternador" maxlength="100"
                        v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_relay_alternador"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="faro_delantero" label="Faros Delanteros" maxlength="100"
                        v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_faro_delantero"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="direccional_delantero" label="Direccionales Delanteras"
                        maxlength="100" v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_direccional_delantero"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="direccional_posterior" label="Direccionales Posteriores"
                        maxlength="100" v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_direccional_posterior"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="luz_posterior" label="Luces Posteriores" maxlength="100"
                        v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_luz_posterior"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="auto_radio" label="Auto Radio" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_auto_radio" :rules="[v => !!v || 'Requerido']"
                        required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="parlante" label="Parlantes" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_parlante" :rules="[v => !!v || 'Requerido']"
                        required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="claxon" label="Claxon" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_claxon" :rules="[v => !!v || 'Requerido']"
                        required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="circuito_luz" label="Circuito de Luces(Faros cables)"
                        maxlength="100" v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_circuito_luz"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                  </v-row>
                </v-container>
                <v-container>
                  <v-toolbar-title class="mb-3 info--text">5. Sistema de Transmisión</v-toolbar-title>
                  <v-row>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="caja_cambio" label="Caja de Cambios" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_caja_cambio"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="bomba_embrague" label="Bomba de Embrague" maxlength="100"
                        v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_bomba_embrague"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="caja_transferencia" label="Caja de Transferencia"
                        maxlength="100" v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_caja_transferencia"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="diferencial_trasero" label="Diferencial Trasero" maxlength="100"
                        v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_diferencial_trasero"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="diferencial_delantero_4x4" label="Diferencial Delantero 4x4"
                        maxlength="100" v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_diferencial_delantero_4x4"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                  </v-row>
                </v-container>
                <v-container>
                  <v-toolbar-title class="mb-3 info--text">6. Sistema de Dirección</v-toolbar-title>
                  <v-row>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="volante" label="Volante" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_volante" :rules="[v => !!v || 'Requerido']"
                        required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="cana_direccion" label="Caña de Dirección" maxlength="100"
                        v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_cana_direccion"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="cremallera" label="Cremallera" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_cremallera" :rules="[v => !!v || 'Requerido']"
                        required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="rotula" label="Rótulas" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_rotula" :rules="[v => !!v || 'Requerido']"
                        required hide-details></v-select>
                    </v-col>
                  </v-row>
                </v-container>
                <v-container>
                  <v-toolbar-title class="mb-3 info--text">7. Sistema de Suspensión</v-toolbar-title>
                  <v-row>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="amortiguador_muelle" label="Amortiguadores / Muelles"
                        maxlength="100" v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_amortiguador_muelle"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="barra_torsion" label="Barra de Torsión" maxlength="100"
                        v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_barra_torsion"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="barra_estabilizadora" label="Barra Estabilizadora"
                        maxlength="100" v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_barra_estabilizadora"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="llanta" label="Llantas" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_llanta" :rules="[v => !!v || 'Requerido']"
                        required hide-details></v-select>
                    </v-col>
                  </v-row>
                </v-container>
                <v-container>
                  <v-toolbar-title class="mb-3 info--text">8. Carroceria</v-toolbar-title>
                  <v-row>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="capot_motor" label="Capot del Motor" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_capot_motor"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="capot_maletera" label="Capot de la Maletera" maxlength="100"
                        v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_capot_maletera"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="parachoque_delatero" label="Parachoques Delanteros"
                        maxlength="100" v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_parachoque_delatero"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="parachoque_posterior" label="Parachoques Posteriores"
                        maxlength="100" v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_parachoque_posterior"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="luna_lateral" label="Lunas Laterales" maxlength="100"
                        v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_luna_lateral"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="luna_cortaviento" label="Lunas Cortaviento" maxlength="100"
                        v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_luna_cortaviento"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="parabrisa_delantero" label="Parabrisas Delanteros"
                        maxlength="100" v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_parabrisa_delantero"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="parabrisa_posterior" label="Parabrisas Posterior"
                        maxlength="100" v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_parabrisa_posterior"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="tanque_combustible" label="Tanque de Combustible"
                        maxlength="100" v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_tanque_combustible"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="puerta" label="Puertas" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_puerta" :rules="[v => !!v || 'Requerido']"
                        required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="asiento" label="Asientos" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_asiento" :rules="[v => !!v || 'Requerido']"
                        required hide-details></v-select>
                    </v-col>
                  </v-row>
                </v-container>
                <v-container>
                  <v-toolbar-title class="mb-3 info--text">9. Accesorios</v-toolbar-title>
                  <v-row>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="aire_acondicionado" label="Aire Acondicionado" maxlength="100"
                        v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_aire_acondicionado"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="alarma" label="Alarma" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_alarma" :rules="[v => !!v || 'Requerido']"
                        required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="plumilla" label="Plumillas" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_plumilla" :rules="[v => !!v || 'Requerido']"
                        required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="espejo" label="Espejos" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_espejo" :rules="[v => !!v || 'Requerido']"
                        required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="cinturon_seguridad" label="Cinturones de Seguridad"
                        maxlength="100" v-uppercase hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_cinturon_seguridad"
                        :rules="[v => !!v || 'Requerido']" required hide-details></v-select>
                    </v-col>
                    <v-col cols="8" md="5" sm="4">
                      <v-text-field dense v-model.trim="antena" label="Antena" maxlength="100" v-uppercase
                        hide-details></v-text-field>
                    </v-col>
                    <v-col cols="4" md="1" sm="2">
                      <v-select dense :items="con_vehiculos" v-model="con_antena" :rules="[v => !!v || 'Requerido']"
                        required hide-details></v-select>
                    </v-col>
                  </v-row>
                </v-container>
                <v-container>
                  <v-toolbar-title class="mb-3 info--text">10. Otras Caracteristicas Relevantes</v-toolbar-title>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea dense rows="4" v-model.trim="otra_caracteristica_relevante" maxlength="450"
                        v-uppercase hide-details></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
                <v-container>
                  <v-toolbar-title class="mb-3 info--text">Apreciación Técnica General (*)</v-toolbar-title>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea dense rows="4" v-model.trim="apreciacion_tecnica_general" maxlength="450" v-uppercase
                        hide-details></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
                <!-- Mensaje error bien -->
                <v-col cols="12" v-if="mensajeBien != ''">
                  <v-alert text dense type="error">{{ mensajeBien }}</v-alert>
                </v-col>
                <!-- Mensaje error bien -->
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
        <!-- Fin Mostrar Modal detalle vehiculo -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import jsPDF from "jspdf";
import moment from "moment"; // Formatear Fechas
import numeral from "numeral"; // Formater numeros
import pdf from "vue-pdf"; // Visor de pdf
import { mapState, mapGetters } from "vuex";
import { BrowserMultiFormatReader } from '@zxing/library';
import ExcelJS from 'exceljs';

export default {
  components: {
    pdf,
  },
  data() {
    return {
      bienes: [],
      dialog: false,
      cabBienes: [
        { text: "OPCIONES", value: "opciones", sortable: false },
        { text: "Cód. Patrimonial", value: "codbien", sortable: false, width: 135 },
        //{ text: "C/Int.", value: "codinterno", sortable: false },
        { text: "Tipo Bien", value: "tbdescripcion", sortable: false },
        { text: "Ubicación", value: "ubicacion", sortable: false },
        { text: "Modificado por", value: "actividad", sortable: false },
      ],

      editedIndex: -1,
      editedIndexDetVeh: -1,
      codcondicion: "",
      gencodpatrimonial: false,

      // Escaner barra
      dialogCamara: false,
      lector: null,
      escaneando: false,

      codigo_barra: "",

      modificarBien: false,
      // Frm bien
      idbien: "",
      codbien: "",
      codbienint: "",
      codinterno: "",
      codlocal: "", // selectLocalArray
      codtipobien: "", // selectTipobienArray
      correlativo: "",
      codarea: "", // selectAreaArray
      idasignacion: "", // selectAsignacionArray
      imagen: "",
      imagen2: "",
      imagen3: "",
      marca: "",
      modelo: "",
      tipo: "",
      color: "",
      serie: "",
      dimension: "",
      nummotor: "",
      numchasis: "",
      placa: "",
      ano: "",

      carroceria: "",
      nro_ejes: "",
      combustible: "",
      transmision: "",
      cilindrada: "",
      kilometraje: "",
      tarjeta_propiedad: "",

      asegurado: "N",
      otras_caract: "",
      fec_reg: "",
      doc_alta: "",
      tipo_cta: "", // tipo_ctas
      cuenta: "", // selectCuentascArray
      valordq: "",
      valorlibro: "",
      clasif_presup_gasto: "",
      flg_cond: "", // flg_conds
      flg_estado: "", // flg_estados
      situacion: "U",
      flg_causal: "",
      resol_baja: "",
      fec_baja: "",

      idusuario: "",
      observacion: "",
      // Fin Frm bien
      buscar: "",
      correlative: "",

      grupo: "",
      clase: "",

      mensajeBien: "",

      // Select
      selectCuentascArray: [],

      selectTipobienArray: [],
      buscar_tipobien: "",

      selectAsignacionArray: [],
      buscar_personal: "",

      fecha_registro_formateado: "",
      menuFechaRegistro: false,

      fecha_baja_formateado: "", // baja
      menuFechaBaja: false,

      disabledcodtipobien: false,

      stringPdf: "",
      srcPdf: "",
      blobPdf: "",
      numPages: undefined,
      verBienModalImp: 0,
      verBajaBienModal: 0,
      // Fin Select

      desabilitar: false,
      desabilitarDetVeh: false,
      isValid: true,
      alerta: { snackbar: false, color: "", text: "" },

      adModal: 0,
      adAccion: 0,
      adId: "",

      imagenxdefec: "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",

      file: null,
      file2: null,
      file3: null,
      urlTemporal: "",
      urlTemporal2: "",
      urlTemporal3: "",

      verDetVehiculo: false,

      fechaActual: moment().startOf("day").format("YYYY-MM-DD"),
      //#region Detalle Vehiculo
      con_vehiculos: [
        { text: "SI" },
        { text: "NO" },
      ],
      iddetalle_vehiculo: "",
      // 1 Motor
      cilindro: "",
      con_cilindro: "NO",
      carburador_carter: "",
      con_carburador_carter: "NO",
      distribuidor_bomba_inyeccion: "",
      con_distribuidor_bomba_inyeccion: "NO",
      bomba_gasolina: "",
      con_bomba_gasolina: "NO",
      purificador_aire: "",
      con_purificador_aire: "NO",
      // 2 Frenos
      bomba_freno: "",
      con_bomba_freno: "NO",
      zapata_tambor: "",
      con_zapata_tambor: "NO",
      disco_pastilla: "",
      con_disco_pastilla: "NO",
      // 3 Refrigeracion
      radiador: "",
      con_radiador: "NO",
      ventilador: "",
      con_ventilador: "NO",
      bomba_agua: "",
      con_bomba_agua: "NO",
      // 4 Electrico
      motor_arranque: "",
      con_motor_arranque: "NO",
      bateria: "",
      con_bateria: "NO",
      alternador: "",
      con_alternador: "NO",
      bobina: "",
      con_bobina: "NO",
      relay_alternador: "",
      con_relay_alternador: "NO",
      faro_delantero: "",
      con_faro_delantero: "NO",
      direccional_delantero: "",
      con_direccional_delantero: "NO",
      direccional_posterior: "",
      con_direccional_posterior: "NO",
      luz_posterior: "",
      con_luz_posterior: "NO",
      auto_radio: "",
      con_auto_radio: "NO",
      parlante: "",
      con_parlante: "NO",
      claxon: "",
      con_claxon: "NO",
      circuito_luz: "",
      con_circuito_luz: "NO",
      // 5 Transmision
      caja_cambio: "",
      con_caja_cambio: "NO",
      bomba_embrague: "",
      con_bomba_embrague: "NO",
      caja_transferencia: "",
      con_caja_transferencia: "NO",
      diferencial_trasero: "",
      con_diferencial_trasero: "NO",
      diferencial_delantero_4x4: "",
      con_diferencial_delantero_4x4: "NO",
      // 6 Direccion
      volante: "",
      con_volante: "NO",
      cana_direccion: "",
      con_cana_direccion: "NO",
      cremallera: "",
      con_cremallera: "NO",
      rotula: "",
      con_rotula: "NO",
      // 7 Suspension
      amortiguador_muelle: "",
      con_amortiguador_muelle: "NO",
      barra_torsion: "",
      con_barra_torsion: "NO",
      barra_estabilizadora: "",
      con_barra_estabilizadora: "NO",
      llanta: "",
      con_llanta: "NO",
      // 8 Carroceria
      capot_motor: "",
      con_capot_motor: "NO",
      capot_maletera: "",
      con_capot_maletera: "NO",
      parachoque_delatero: "",
      con_parachoque_delatero: "NO",
      parachoque_posterior: "",
      con_parachoque_posterior: "NO",
      luna_lateral: "",
      con_luna_lateral: "NO",
      luna_cortaviento: "",
      con_luna_cortaviento: "NO",
      parabrisa_delantero: "",
      con_parabrisa_delantero: "NO",
      parabrisa_posterior: "",
      con_parabrisa_posterior: "NO",
      tanque_combustible: "",
      con_tanque_combustible: "NO",
      puerta: "",
      con_puerta: "NO",
      asiento: "",
      con_asiento: "NO",
      // 9 Accesorios
      aire_acondicionado: "",
      con_aire_acondicionado: "NO",
      alarma: "",
      con_alarma: "NO",
      plumilla: "",
      con_plumilla: "NO",
      espejo: "",
      con_espejo: "NO",
      cinturon_seguridad: "",
      con_cinturon_seguridad: "NO",
      antena: "",
      con_antena: "NO",
      // 10 Otras Caracteristicas relevantes
      otra_caracteristica_relevante: "",
      apreciacion_tecnica_general: "",
      //#endregion
    };
  },

  computed: {
    ...mapState(["usuarioState", "empresaState"]),
    ...mapGetters(["esSuperadministrador", "esAdministrador", "esSupervisor", "esVerificador"]),

    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Bien" : "Actualizar Bien";
    },
    formTitleDetVeh() {
      return this.editedIndexDetVeh === -1 ? "Crear" : "Actualizar";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
  },

  methods: {

    //#region CAPTURA
    iniciarEscaneo() {
      this.codigo_barra = ""
      this.lector = new BrowserMultiFormatReader()
      this.escaneando = true
      this.dialogCamara = true

      this.$nextTick(() => {
        // Espera a que el DOM se actualice (video disponible)
        this.lector.decodeFromConstraints(
          {
            video: {
              facingMode: "environment",
              width: { ideal: 1920 },
              height: { ideal: 1080 }
            }
          },
          this.$refs.video,
          (result, err) => {
            if (result && this.escaneando) {
              this.codigo_barra = result.getText()
              this.detenerEscaneo()
              this.buscarCodigoBarra()
            }
          }
        )
        /* this.lector.decodeFromVideoDevice(null, this.$refs.video, (result, err) => {
          if (result && this.escaneando) {
            this.codigo_barra = result.getText()
            this.detenerEscaneo()
            this.buscarCodigoBarra()
          }
        }) */
      })
    },

    detenerEscaneo() {
      if (this.lector) {
        this.lector.reset()
        this.escaneando = false
        this.dialogCamara = false;
      }
    },
    //#endregion CAPTURA

    // Para descargar pdf de blob
    savePdf() {
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(this.blobPdf);
      var fileName = "Ficha de bien " + this.codbien;
      link.download = fileName;
      link.click();
    },

    // Llamamos de main.js printJS
    printExternal() {
      printJS({
        printable: this.stringPdf.replace(
          "data:application/pdf;filename=generated.pdf;base64,",
          ""
        ),
        type: "pdf",
        base64: true,
      });
    },

    /* Listar bienes */
    listar() {
      let me = this;
      me.loading = true;

      if (me.correlative == "") {
        axios.get("api/Bienes/ListarBienEmpresaFiltro", {
          params: {
            idempresa: me.usuarioState.idempresa,
            buscar: me.buscar,
          },
        })
          .then(function (response) {
            me.bienes = response.data;
            me.loading = false;
          })
          .catch((err) => {
            //console.log(err.response);
          });
      } else {
        axios.get("api/Bienes/ListarBienEmpresaFiltroCorrelative", {
          params: {
            idempresa: me.usuarioState.idempresa,
            buscar: me.buscar,
            correlative: me.correlative.padStart(4, 0),
          },
        })
          .then(function (response) {
            me.bienes = response.data;
            me.loading = false;
          })
          .catch((err) => {
            //console.log(err.response);
          });
      }
    },

    buscarCodigoBarra() {
      let me = this;
      me.loading = true;
      /* if (me.codigo_barra.length < 12) {
      me.loading = false;
      me.alerta.snackbar = true;
      me.alerta.color = "info";
      return (me.alerta.text = "El Código de barra no es valido.");
      } */

      axios
        .get("api/Bienes/BuscarCodigoBarraBien/" + me.codigo_barra + "/" + me.usuarioState.idempresa)
        .then(function (response) {
          var data = [response.data];
          me.bienes = data;
          //console.log(data);
          me.alerta.snackbar = true;
          me.alerta.color = "success";
          me.alerta.text = "El código de bien '" + me.codigo_barra + "'. Existe en la base de datos.";
          me.loading = false;
          me.loading = false;
          //me.codigo_barra = "";
        })
        .catch(function (error) {
          me.alerta.snackbar = true;
          me.alerta.color = "error";
          me.alerta.text = "El Código de bien '" + me.codigo_barra + "'. No existe en la base de datos.";
          me.loading = false;
          //console.log(error);
        });
    },
    /* Fin Listar bienes */

    // Seleccionar Cuenta y tipobien por busqueda
    selectCcontable(id) {
      let me = this;
      me.selectCuentascArray = []; // Limpiamos para llenar nuevamente
      var cuentacArray = [];

      let url = "";
      if (id) {
        url = "api/Cuentasc/SelectCuentac?buscar=" + (id == "" ? "-" : id);
      } else {
        if (me.usuarioState.tipoempresa == "ESTATAL") {
          url = "api/Cuentasc/SelectCuentascEstatal?tipo_cta=" + me.tipo_cta;
        } else {
          url = "api/Cuentasc/SelectCuentascPrivado?tipo_cta=" + me.tipo_cta;
        }
      }
      axios
        .get(url)
        .then(function (response) {
          cuentacArray = response.data;
          cuentacArray.map(function (x) {
            me.selectCuentascArray.push({
              text: x.cuenta + " " + x.denominacion,
              value: x.cuenta,
            });
          });
        })
        .catch(function (error) {
          //console.log(url);
        });
    },

    selectGrupoClase() {
      let me = this;
      if (me.codtipobien != null || "") {
        axios
          .get("api/GruposClases/Mostrar", {
            params: {
              idgrupo: me.codtipobien == null ? "" : me.codtipobien.substring(0, 2),
              idclase: me.codtipobien == null ? "" : me.codtipobien.substring(2, 4),
            },
          })
          .then(function (response) {
            var data = [response.data];
            me.cuenta = data[0].cuenta;
            me.tipo_cta = data[0].tipo_cta;

            me.selectCcontable(me.cuenta);
            //console.log(data);
          })
          .catch(function (error) { });
      }
    },

    mostrarGrupoClase() {
      let me = this;
      if (me.codtipobien != null || "") {
        axios
          .get("api/Grupos/Mostrar", {
            params: {
              idgrupo: me.codtipobien == null ? "" : me.codtipobien.substring(0, 2),
            },
          })
          .then(function (response) {
            var data = [response.data];
            me.grupo = data[0].dscgrupo;
          })
          .catch(function (error) { });

        axios
          .get("api/Clases/Mostrar", {
            params: {
              idclase: me.codtipobien == null ? "" : me.codtipobien.substring(2, 4),
            },
          })
          .then(function (response) {
            var data = [response.data];
            me.clase = data[0].dscclase;
          })
          .catch(function (error) { });
      }
    },

    selectTbien(id) {
      let me = this;
      var bienArray = [];

      let url = "";
      if (id) {
        url = "api/Tipobienes/SelectTipoBien?buscar=" + (id == "" ? "-" : id);
      } else {
        url = "api/Tipobienes/SelectTipoBienesFiltro?buscar=" + (me.buscar_tipobien == "" ? "-" : me.buscar_tipobien == null ? "-" : me.buscar_tipobien);
      }
      axios
        .get(url)
        .then(function (response) {
          bienArray = response.data;
          bienArray.map(function (x) {
            me.selectTipobienArray.push({
              text: x.codtipobien + " " + x.descripcion,
              value: x.codtipobien,
            });
          });
        })
        .catch(function (error) {
          //console.log(url);
        });
    },

    selectAsignacion(id) {
      let me = this;
      var asignacionArray = [];

      if (id) {
        // Select idasignacion
        axios
          .get(
            "api/Asignaciones/SelectAsignacion?idasignacion=" +
            (id == "" ? "-" : id)
          )
          .then(function (response) {
            asignacionArray = response.data;
            asignacionArray.map(function (x) {
              me.selectAsignacionArray.push({
                text: x.nompersonal + " | " + x.nomlocal.substring(0, 20) + " > " + x.nomarea.substring(0, 20) + " - " + x.nomoficina.substring(0, 20) + " [" + x.cantbien + "]",
                value: x.idasignacion,
              });
            });
          })
          .catch(function (error) {
            //console.log(url);
          });
      } else {
        axios
          .get("api/Asignaciones/SelectAsignacionBien", {
            params: {
              idempresa: me.usuarioState.idempresa,
              buscar: me.buscar_personal == "" ? "-" : me.buscar_personal == null ? "-" : me.buscar_personal,
            },
          })
          .then(function (response) {
            me.selectAsignacionArray = response.data.map(x => ({
              text: x.nompersonal + " | " + x.nomlocal.substring(0, 20) + " > " + x.nomarea.substring(0, 20) + " - " + x.nomoficina + " [" + x.cantbien + "]",
              nom: x.nompersonal,
              nrodoc: x.nrodocpersonal,
              local: x.nomlocal,
              area: x.nomarea,
              oficina: x.nomoficina,
              direccion: x.direclocal,
              value: x.idasignacion,
            }));
          })
          .catch((err) => {
            //console.log(err.response);
          });
      }
    },

    // Fin Seleccionar Cuenta y tipobien por busqueda

    /* Editar y guardar bien */
    guardar() {
      let me = this;
      me.desabilitar = true;

      if (me.editedIndex > -1) {
        //Código para editar
        axios
          .put("api/bienes/Actualizar", {
            idbien: me.idbien,
            codbien: me.codbien,
            idempresa: me.idempresa,
            idasignacion: me.idasignacion,
            imagen: me.imagen,
            imagen2: me.imagen2,
            imagen3: me.imagen3,
            marca: me.marca,
            modelo: me.modelo,
            tipo: me.tipo,
            color: me.color,
            serie: me.serie,
            dimension: me.dimension,
            nummotor: me.nummotor,
            numchasis: me.numchasis,
            placa: me.placa,
            ano: me.ano,

            carroceria: me.carroceria,
            nro_ejes: me.nro_ejes,
            combustible: me.combustible,
            transmision: me.transmision,
            cilindrada: me.cilindrada,
            kilometraje: me.kilometraje,
            tarjeta_propiedad: me.tarjeta_propiedad,

            asegurado: me.asegurado,
            otras_caract: me.otras_caract,
            fec_reg: me.fec_reg,
            doc_alta: me.doc_alta,
            tipo_cta: me.tipo_cta, // tipo_ctas
            cuenta: me.cuenta, // selectCuentascArray
            valordq: me.valordq == "" ? 0 : me.cm.removeComa(me.valordq),
            valorlibro: me.valorlibro == "" ? 0 : me.cm.removeComa(me.valorlibro),
            flg_cond: me.flg_cond, // flg_conds
            flg_estado: me.flg_estado, // flg_estados
            idusuario: parseInt(me.usuarioState.idusuario),
            observacion: me.observacion,
            situacion: me.situacion,
            clasif_presup_gasto: me.clasif_presup_gasto,

            gencodpatrimonial: me.gencodpatrimonial, // SI o No

            seguimiento_inv: me.usuarioState.seguimientoinv,
          })
          .then(function (response) {
            me.desabilitar = false;
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.mensajeBien = error.response.data;
            me.limpiarAlertaError();
          });
      } else {
        //Código para guardar
        axios
          .post("api/bienes/Crear", {
            codtipobien: me.codtipobien,
            idempresa: me.usuarioState.idempresa,
            idasignacion: me.idasignacion,
            imagen: me.imagen,
            imagen2: me.imagen2,
            imagen3: me.imagen3,
            marca: me.marca,
            modelo: me.modelo,
            tipo: me.tipo,
            color: me.color,
            serie: me.serie,
            dimension: me.dimension,
            nummotor: me.nummotor,
            numchasis: me.numchasis,
            placa: me.placa,
            ano: me.ano,

            carroceria: me.carroceria,
            nro_ejes: me.nro_ejes,
            combustible: me.combustible,
            transmision: me.transmision,
            cilindrada: me.cilindrada,
            kilometraje: me.kilometraje,
            tarjeta_propiedad: me.tarjeta_propiedad,

            asegurado: me.asegurado,
            otras_caract: me.otras_caract,
            fec_reg: me.fec_reg,
            doc_alta: me.doc_alta,
            tipo_cta: me.tipo_cta, // tipo_ctas
            cuenta: me.cuenta, // selectCuentascArray
            valordq: me.valordq == "" ? 0 : me.cm.removeComa(me.valordq),
            valorlibro: me.valorlibro == "" ? 0 : me.cm.removeComa(me.valorlibro),
            flg_cond: me.flg_cond, // flg_conds
            flg_estado: me.flg_estado, // flg_estados
            idusuario: parseInt(me.usuarioState.idusuario),
            observacion: me.observacion,
            situacion: me.situacion,
            clasif_presup_gasto: me.clasif_presup_gasto,

            codcondicion: me.codcondicion, // Patrimonial o Interno

            seguimiento_inv: me.usuarioState.seguimientoinv,
          })
          .then(function (response) {
            me.desabilitar = false;
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.mensajeBien = error.response.data;
            me.limpiarAlertaError();
          });
      }
    },

    guardarBaja() {
      let me = this;
      me.desabilitar = true;

      //Código para editar
      axios
        .put("api/bienes/BajaBien", {
          idbien: me.idbien,
          codbien: me.codbien,
          idempresa: me.idempresa,
          idasignacion: me.idasignacion,
          imagen: me.imagen,
          imagen2: me.imagen2,
          imagen3: me.imagen3,
          marca: me.marca,
          modelo: me.modelo,
          tipo: me.tipo,
          color: me.color,
          serie: me.serie,
          dimension: me.dimension,
          nummotor: me.nummotor,
          numchasis: me.numchasis,
          placa: me.placa,
          ano: me.ano,

          carroceria: me.carroceria,
          nro_ejes: me.nro_ejes,
          combustible: me.combustible,
          transmision: me.transmision,
          cilindrada: me.cilindrada,
          kilometraje: me.kilometraje,
          tarjeta_propiedad: me.tarjeta_propiedad,

          asegurado: me.asegurado,
          otras_caract: me.otras_caract,
          fec_reg: me.fec_reg,
          doc_alta: me.doc_alta,
          tipo_cta: me.tipo_cta, // tipo_ctas
          cuenta: me.cuenta, // selectCuentascArray
          valordq: me.valordq == "" ? 0 : me.cm.removeComa(me.valordq),
          valorlibro: me.valorlibro == "" ? 0 : me.cm.removeComa(me.valorlibro),
          flg_cond: me.flg_cond, // flg_conds
          flg_estado: me.flg_estado, // flg_estados

          flg_causal: me.flg_causal, // flg_causal
          resol_baja: me.resol_baja,
          fec_baja: me.fec_baja,

          idusuario: parseInt(me.usuarioState.idusuario),
          observacion: me.observacion,
          situacion: me.situacion,
        })
        .then(function (response) {
          me.desabilitar = false;
          me.alerta.snackbar = true;
          me.alerta.color = "success";
          me.alerta.text = response.data;
          me.close();
          me.listar();
          me.limpiar();
        })
        .catch(function (error) {
          me.desabilitar = false;
          me.mensajeBien = error.response.data;
          me.limpiarAlertaError();
        });
    },
    /* Fin Editar y guardar bien */

    /* Buscar imagen bien */
    buscarImagen(event) {
      //console.log(event.target.files[0]);
      const fileCargado = event.target.files[0];
      // Verificamos si tenemos imagen en fileCargado
      if (fileCargado) {
        const reader = new FileReader();
        reader.readAsDataURL(fileCargado);
        reader.onload = (e) => {
          this.urlTemporal = e.target.result; // Visualizamos en Base64 al usuario despues de cargar imagen
        };

        // Reducimos imagen con un ancho de 300px
        var resizeImage = function (settings) {
          var file = settings.file;
          var maxSize = settings.maxSize;
          var reader = new FileReader();
          var image = new Image();
          var canvas = document.createElement("canvas");
          var dataURItoBlob = function (dataURI) {
            var bytes = dataURI.split(",")[0].indexOf("base64") >= 0 ? atob(dataURI.split(",")[1]) : unescape(dataURI.split(",")[1]);
            var mime = dataURI.split(",")[0].split(":")[1].split(";")[0];
            var max = bytes.length;
            var ia = new Uint8Array(max);
            for (var i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i);
            return new Blob([ia], { type: mime });
          };
          var resize = function () {
            var width = image.width;
            var height = image.height;
            if (width > height) {
              if (width > maxSize) {
                height *= maxSize / width;
                width = maxSize;
              }
            } else {
              if (height > maxSize) {
                width *= maxSize / height;
                height = maxSize;
              }
            }
            canvas.width = width;
            canvas.height = height;
            canvas.getContext("2d").drawImage(image, 0, 0, width, height);
            var dataUrl = canvas.toDataURL("image/jpeg");
            return dataUrl;
            //return dataURItoBlob(dataUrl);
          };
          return new Promise(function (ok, no) {
            if (!file.type.match(/image.*/)) {
              no(new Error("Not an image"));
              return;
            }
            reader.onload = function (readerEvent) {
              image.onload = function () {
                return ok(resize());
              };
              image.src = readerEvent.target.result;
            };
            reader.readAsDataURL(file);
          });
        };
        // llamamos a funcion para reducir imagen a imagen Blob
        resizeImage({
          file: fileCargado,
          maxSize: 300,
        })
          .then((resizedImage) => {
            this.imagen = resizedImage.replace("data:image/jpeg;base64,", ""); // Cargamos imagen reducida para guardar y reemplazamos data... x un valor vacio
          })
          .catch((err) => {
            console.error(err);
          });
        // Fin Reducimos imagen con un ancho de 700px
      }
    },
    buscarImagen2(event) {
      //console.log(event.target.files[0]);
      const fileCargado = event.target.files[0];
      // Verificamos si tenemos imagen en fileCargado
      if (fileCargado) {
        const reader = new FileReader();
        reader.readAsDataURL(fileCargado);
        reader.onload = (e) => {
          this.urlTemporal2 = e.target.result; // Visualizamos en Base64 al usuario despues de cargar imagen
        };

        // Reducimos imagen con un ancho de 300px
        var resizeImage = function (settings) {
          var file = settings.file;
          var maxSize = settings.maxSize;
          var reader = new FileReader();
          var image = new Image();
          var canvas = document.createElement("canvas");
          var dataURItoBlob = function (dataURI) {
            var bytes = dataURI.split(",")[0].indexOf("base64") >= 0 ? atob(dataURI.split(",")[1]) : unescape(dataURI.split(",")[1]);
            var mime = dataURI.split(",")[0].split(":")[1].split(";")[0];
            var max = bytes.length;
            var ia = new Uint8Array(max);
            for (var i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i);
            return new Blob([ia], { type: mime });
          };
          var resize = function () {
            var width = image.width;
            var height = image.height;
            if (width > height) {
              if (width > maxSize) {
                height *= maxSize / width;
                width = maxSize;
              }
            } else {
              if (height > maxSize) {
                width *= maxSize / height;
                height = maxSize;
              }
            }
            canvas.width = width;
            canvas.height = height;
            canvas.getContext("2d").drawImage(image, 0, 0, width, height);
            var dataUrl = canvas.toDataURL("image/jpeg");
            return dataUrl;
            //return dataURItoBlob(dataUrl);
          };
          return new Promise(function (ok, no) {
            if (!file.type.match(/image.*/)) {
              no(new Error("Not an image"));
              return;
            }
            reader.onload = function (readerEvent) {
              image.onload = function () {
                return ok(resize());
              };
              image.src = readerEvent.target.result;
            };
            reader.readAsDataURL(file);
          });
        };
        // llamamos a funcion para reducir imagen a imagen Blob
        resizeImage({
          file: fileCargado,
          maxSize: 300,
        })
          .then((resizedImage) => {
            this.imagen2 = resizedImage.replace("data:image/jpeg;base64,", ""); // Cargamos imagen reducida para guardar y reemplazamos data... x un valor vacio
          })
          .catch((err) => {
            console.error(err);
          });
        // Fin Reducimos imagen con un ancho de 700px
      }
    },
    buscarImagen3(event) {
      //console.log(event.target.files[0]);
      const fileCargado = event.target.files[0];
      // Verificamos si tenemos imagen en fileCargado
      if (fileCargado) {
        const reader = new FileReader();
        reader.readAsDataURL(fileCargado);
        reader.onload = (e) => {
          this.urlTemporal3 = e.target.result; // Visualizamos en Base64 al usuario despues de cargar imagen
        };

        // Reducimos imagen con un ancho de 300px
        var resizeImage = function (settings) {
          var file = settings.file;
          var maxSize = settings.maxSize;
          var reader = new FileReader();
          var image = new Image();
          var canvas = document.createElement("canvas");
          var dataURItoBlob = function (dataURI) {
            var bytes = dataURI.split(",")[0].indexOf("base64") >= 0 ? atob(dataURI.split(",")[1]) : unescape(dataURI.split(",")[1]);
            var mime = dataURI.split(",")[0].split(":")[1].split(";")[0];
            var max = bytes.length;
            var ia = new Uint8Array(max);
            for (var i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i);
            return new Blob([ia], { type: mime });
          };
          var resize = function () {
            var width = image.width;
            var height = image.height;
            if (width > height) {
              if (width > maxSize) {
                height *= maxSize / width;
                width = maxSize;
              }
            } else {
              if (height > maxSize) {
                width *= maxSize / height;
                height = maxSize;
              }
            }
            canvas.width = width;
            canvas.height = height;
            canvas.getContext("2d").drawImage(image, 0, 0, width, height);
            var dataUrl = canvas.toDataURL("image/jpeg");
            return dataUrl;
            //return dataURItoBlob(dataUrl);
          };
          return new Promise(function (ok, no) {
            if (!file.type.match(/image.*/)) {
              no(new Error("Not an image"));
              return;
            }
            reader.onload = function (readerEvent) {
              image.onload = function () {
                return ok(resize());
              };
              image.src = readerEvent.target.result;
            };
            reader.readAsDataURL(file);
          });
        };
        // llamamos a funcion para reducir imagen a imagen Blob
        resizeImage({
          file: fileCargado,
          maxSize: 300,
        })
          .then((resizedImage) => {
            this.imagen3 = resizedImage.replace("data:image/jpeg;base64,", ""); // Cargamos imagen reducida para guardar y reemplazamos data... x un valor vacio
          })
          .catch((err) => {
            console.error(err);
          });
        // Fin Reducimos imagen con un ancho de 700px
      }
    },
    /* Fin Buscar imagen bien */

    /* Formatear fecha registro */
    fechaRegistroSeleccionada(dia) {
      let arrayFecha = dia.split(["-"]);
      let ddmmyy = arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
      this.fecha_registro_formateado = ddmmyy;
    },

    fechaBajaSeleccionada(dia) {
      let arrayFecha = dia.split(["-"]);
      let ddmmyy = arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
      this.fecha_baja_formateado = ddmmyy;
    },
    /* Fin Formatear fecha registro */

    /* Eliminar bien */
    deleteItem(item) {
      const respta = confirm(
        "¿Estás seguro de que deseas eliminar el bien " + item.codbien + "?"
      );
      if (respta) {
        let me = this;
        axios
          .delete("api/bienes/Eliminar/" + item.idbien)
          .then((response) => {
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            this.listar();
          })
          .catch(function (error) {
            me.alerta.snackbar = true;
            me.alerta.color = "error";
            me.alerta.text = error.response.data;
          });
      }
    },
    /* Fin Eliminar bien */

    /* Limpiar mensaje bien */
    limpiarAlertaError() {
      setTimeout(() => {
        this.mensajeBien = "";
      }, 3000);
    },
    /* Fin Limpiar mensaje bien */

    /* Editar bien item */
    editBienItem(item, ed) {
      ed == 'd' ? (this.idbien = '', this.codbien = '') : (this.idbien = item.idbien, this.codbien = item.codbien);
      //this.idbien = item.idbien;
      //this.codbien = item.codbien;
      this.codbienint = item.codbienint;
      this.codinterno = item.codinterno;
      this.codtipobien = item.codtipobien; // selectTbien
      this.selectTbien(item.codtipobien);
      this.correlativo = item.correlativo;
      this.idempresa = item.idempresa;
      this.idasignacion = item.idasignacion;
      this.selectAsignacion(item.idasignacion);
      this.imagen = (ed == 'd' ? null : item.imagen);
      this.imagen2 = (ed == 'd' ? null : item.imagen2);
      this.imagen3 = (ed == 'd' ? null : item.imagen3);
      this.marca = item.marca;
      this.modelo = item.modelo;
      this.tipo = item.tipo;
      this.color = item.color;
      this.serie = item.serie;
      this.dimension = item.dimension;
      this.nummotor = item.nummotor;
      this.numchasis = item.numchasis;
      this.placa = item.placa;
      this.ano = item.ano;

      this.carroceria = item.carroceria;
      this.nro_ejes = item.nro_ejes;
      this.combustible = item.combustible;
      this.transmision = item.transmision;
      this.cilindrada = item.cilindrada;
      this.kilometraje = item.kilometraje;
      this.tarjeta_propiedad = item.tarjeta_propiedad;

      this.asegurado = item.asegurado;
      this.otras_caract = item.otras_caract;
      this.fec_reg = item.fec_reg;
      this.fechaRegistroSeleccionada(item.fec_reg);
      this.doc_alta = item.doc_alta;
      this.tipo_cta = item.tipo_cta;
      this.cuenta = item.cuenta; // selectCcontable
      this.selectCcontable(item.cuenta);
      this.valordq = parseFloat(item.valordq).toFixed(2);
      this.valorlibro = parseFloat(item.valorlibro).toFixed(2);
      this.flg_cond = item.flg_cond;
      this.flg_estado = item.flg_estado;
      this.idusuario = item.idusuario;
      this.observacion = item.observacion;
      this.situacion = item.situacion;
      this.clasif_presup_gasto = item.clasif_presup_gasto;
      this.mostrarGrupoClase();

      this.modificarBien = this.esVerificador ? true : false;
      this.disabledcodtipobien = true; //para tipo bien
      this.codcondicion = item.codbien.length == 12 ? 'Patrimonial' : 'Interno';
      this.gencodpatrimonial = false;
      this.iddetalle_vehiculo = item.iddetalle_vehiculo; // id de detalle vehiculo para editar != null o crear == null
      //this.editedIndex = 1;
      ed == "d" ? this.editedIndex = -1 : this.editedIndex = 1;
      this.dialog = true;
    },
    /* Fin Editar bien item */

    /* Baja bien item */
    bajaBienItem(item) {
      this.idbien = item.idbien;
      this.codbien = item.codbien;
      this.codtipobien = item.codtipobien; // selectTbien
      this.selectTbien(item.codtipobien);
      this.correlativo = item.correlativo;
      this.idempresa = item.idempresa;
      this.idasignacion = item.idasignacion;
      this.selectAsignacion(item.idasignacion);
      this.imagen = item.imagen;
      this.imagen2 = item.imagen2;
      this.imagen3 = item.imagen3;
      this.marca = item.marca;
      this.modelo = item.modelo;
      this.tipo = item.tipo;
      this.color = item.color;
      this.serie = item.serie;
      this.dimension = item.dimension;
      this.nummotor = item.nummotor;
      this.numchasis = item.numchasis;
      this.placa = item.placa;
      this.ano = item.ano;

      this.carroceria = item.carroceria;
      this.nro_ejes = item.nro_ejes;
      this.combustible = item.combustible;
      this.transmision = item.transmision;
      this.cilindrada = item.cilindrada;
      this.kilometraje = item.kilometraje;
      this.tarjeta_propiedad = item.tarjeta_propiedad;

      this.asegurado = item.asegurado;
      this.otras_caract = item.otras_caract;
      this.fec_reg = item.fec_reg;
      this.fechaRegistroSeleccionada(item.fec_reg);
      this.doc_alta = item.doc_alta;
      this.tipo_cta = item.tipo_cta;
      this.cuenta = item.cuenta; // selectCcontable
      this.selectCcontable(item.cuenta);
      this.valordq = parseFloat(item.valordq).toFixed(2);
      this.valorlibro = parseFloat(item.valorlibro).toFixed(2);
      this.flg_cond = item.flg_cond;
      this.flg_estado = item.flg_estado;
      this.flg_causal = item.flg_causal;
      this.resol_baja = item.resol_baja;
      this.fec_baja = item.fec_baja;
      this.fechaBajaSeleccionada(item.fec_baja);
      this.idusuario = item.idusuario;
      this.observacion = item.observacion;
      this.situacion = item.situacion;
      this.mostrarGrupoClase();
      this.disabledcodtipobien = true; //para tipo bien

      this.verBajaBienModal = true;
    },
    /* Fin Baja bien item */

    /* Mostrar bien item */
    ocultarBienImp() {
      this.verBienModalImp = 0;
      this.limpiar();
    },
    ocultarBajaBien() {
      this.verBajaBienModal = 0;
      // Limpiamos input carga de imagen
      document.getElementById("file").value = [];
      this.limpiar();
    },

    mostrarBienImp(item) {
      this.codbien = item.codbien;
      this.codbienint = item.codbienint;
      this.codinterno = item.codinterno;
      this.locales = item.locales;
      this.codtipobien = item.codtipobien; // selectTbien
      this.correlativo = item.correlativo;
      this.codlocal = item.codlocal; // selectLocal
      this.areas = item.areas;
      this.codarea = item.codarea;
      this.codempleado = item.codempleado;
      this.empleadodna = item.empleadodna;
      this.imagen = item.imagen;
      this.imagen2 = item.imagen2;
      this.imagen3 = item.imagen3;
      this.marca = item.marca;
      this.modelo = item.modelo;
      this.tipo = item.tipo;
      this.color = item.color;
      this.serie = item.serie;
      this.dimension = item.dimension;
      this.nummotor = item.nummotor;
      this.numchasis = item.numchasis;
      this.placa = item.placa;
      this.ano = item.ano;

      this.carroceria = item.carroceria;
      this.nro_ejes = item.nro_ejes;
      this.combustible = item.combustible;
      this.transmision = item.transmision;
      this.cilindrada = item.cilindrada;
      this.kilometraje = item.kilometraje;
      this.tarjeta_propiedad = item.tarjeta_propiedad;

      this.asegurado = item.asegurado;
      this.otras_caract = item.otras_caract;
      this.fec_reg = item.fec_reg;
      this.doc_alta = item.doc_alta;
      this.tipo_cta = item.tipo_cta;
      this.cuenta = item.cuenta; // selectCcontable
      this.valordq = item.valordq;
      this.valorlibro = item.valorlibro;
      this.flg_cond = item.flg_cond;
      this.flg_estado = item.flg_estado;
      this.observacion = item.observacion;
      this.situacion = item.situacion;

      this.tbdescripcion = item.tbdescripcion;
      this.nomlocales = item.nomlocales;
      this.nomareas = item.nomareas;
      this.pnombres = item.pnombres;
      this.pnrodoc = item.pnrodoc;

      this.verBienModalImp = 1;
      this.crearPDF();
    },
    /* Fin Mostrar bien item */

    /* Cerrar ventana bien */
    close() {
      this.dialog = false;
      this.codcondicion = "";
      this.gencodpatrimonial = false;
      // Limpiamos input carga de imagen
      document.getElementById("file").value = [];
      this.listar(); // Prueba
      this.limpiar();
    },
    /* Fin Cerrar ventana bien */

    /* Limpiar bien item */
    limpiar() {
      this.idbien = "";
      this.codbien = "";
      this.codbienint = "";
      this.codinterno = "";
      this.codtipobien = ""; // selectTipobienArray
      this.correlativo = "";
      this.idempresa = "";
      this.idasignacion = "";
      this.imagen = "";
      this.imagen2 = "";
      this.imagen3 = "";
      this.marca = "";
      this.modelo = "";
      this.tipo = "";
      this.color = "";
      this.serie = "";
      this.dimension = "";
      this.nummotor = "";
      this.numchasis = "";
      this.placa = "";
      this.ano = "";

      this.carroceria = "";
      this.nro_ejes = "";
      this.combustible = "";
      this.transmision = "";
      this.cilindrada = "";
      this.kilometraje = "";
      this.tarjeta_propiedad = "";

      this.otras_caract = "";
      this.fec_reg = "";
      this.fecha_registro_formateado = "";
      this.doc_alta = "";
      this.tipo_cta = ""; // tipo_ctas
      this.cuenta = ""; // selectCuentascArray
      this.valordq = "";
      this.valorlibro = "";
      this.flg_cond = ""; // flg_conds
      this.flg_estado = ""; // flg_estados
      this.idusuario = "";
      this.observacion = "";
      this.situacion = "U";
      this.clasif_presup_gasto = "";

      this.selectTipobienArray = [];
      this.selectAsignacionArray = [];
      this.selectCuentascArray = [];

      this.selectLocalArray = [];
      this.selectAreaArray = [];

      this.disabledcodtipobien = false;

      this.tbdescripcion = "";
      this.nomlocales = "";
      this.nomareas = "";
      this.pnombres = "";
      this.pnrodoc = "";

      this.grupo = "";
      this.clase = "";

      this.mensajeBien = "";
      this.verBajaBienModal = "";

      this.modificarBien = false;

      this.file = null;
      this.file2 = null;
      this.file3 = null;
      this.urlTemporal = "";
      this.urlTemporal2 = "";
      this.urlTemporal3 = "";

      this.stringPdf = "";
      this.srcPdf = "";
      this.blobPdf = "";
      this.verBienModalImp = 0; // Prueba

      this.iddetalle_vehiculo = ""; // id de detalle vehiculo para editar != null o crear == null

      this.editedIndex = -1;
      this.closeDetVehiculo(); // Lipiamos variables detalles del vehiculo
    },
    /* Fin Limpiar bien item */

    /* Reestablecer seguimiento */
    activarMostrar(accion, item) {
      this.adModal = 1;
      this.adId = item.codbien;
      this.idbien = item.idbien;
      if (accion == 1) {
        this.adAccion = 1;
      } else {
        this.adModal = 0;
      }
    },
    activarDesactivarCerrar() {
      this.adModal = 0;
    },
    activar() {
      let me = this;
      axios
        .put("api/Bienes/ReestableserSeguimientoBien/" + this.idbien, {})
        .then(function (response) {
          me.alerta.snackbar = true;
          me.alerta.color = "success";
          me.alerta.text = response.data;
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    /* Fin Reestablecer seguimiento */

    //#region Detalle Vehiculo
    guardarDetVeh() {
      let me = this;
      me.desabilitarDetVeh = true;

      if (me.editedIndexDetVeh > -1) { //Código para editar
        axios.put("api/DetallesVehiculos/Actualizar", {
          idbien: me.idbien,
          // 1 Motor
          cilindro: me.cilindro,
          con_cilindro: me.con_cilindro,
          carburador_carter: me.carburador_carter,
          con_carburador_carter: me.con_carburador_carter,
          distribuidor_bomba_inyeccion: me.distribuidor_bomba_inyeccion,
          con_distribuidor_bomba_inyeccion: me.con_distribuidor_bomba_inyeccion,
          bomba_gasolina: me.bomba_gasolina,
          con_bomba_gasolina: me.con_bomba_gasolina,
          purificador_aire: me.purificador_aire,
          con_purificador_aire: me.con_purificador_aire,
          // 2 Frenos
          bomba_freno: me.bomba_freno,
          con_bomba_freno: me.con_bomba_freno,
          zapata_tambor: me.zapata_tambor,
          con_zapata_tambor: me.con_zapata_tambor,
          disco_pastilla: me.disco_pastilla,
          con_disco_pastilla: me.con_disco_pastilla,
          // 3 Refrigeracion
          radiador: me.radiador,
          con_radiador: me.con_radiador,
          ventilador: me.ventilador,
          con_ventilador: me.con_ventilador,
          bomba_agua: me.bomba_agua,
          con_bomba_agua: me.con_bomba_agua,
          // 4 Electrico
          motor_arranque: me.motor_arranque,
          con_motor_arranque: me.con_motor_arranque,
          bateria: me.bateria,
          con_bateria: me.con_bateria,
          alternador: me.alternador,
          con_alternador: me.con_alternador,
          bobina: me.bobina,
          con_bobina: me.con_bobina,
          relay_alternador: me.relay_alternador,
          con_relay_alternador: me.con_relay_alternador,
          faro_delantero: me.faro_delantero,
          con_faro_delantero: me.con_faro_delantero,
          direccional_delantero: me.direccional_delantero,
          con_direccional_delantero: me.con_direccional_delantero,
          direccional_posterior: me.direccional_posterior,
          con_direccional_posterior: me.con_direccional_posterior,
          luz_posterior: me.luz_posterior,
          con_luz_posterior: me.con_luz_posterior,
          auto_radio: me.auto_radio,
          con_auto_radio: me.con_auto_radio,
          parlante: me.parlante,
          con_parlante: me.con_parlante,
          claxon: me.claxon,
          con_claxon: me.con_claxon,
          circuito_luz: me.circuito_luz,
          con_circuito_luz: me.con_circuito_luz,
          // 5 Transmision
          caja_cambio: me.caja_cambio,
          con_caja_cambio: me.con_caja_cambio,
          bomba_embrague: me.bomba_embrague,
          con_bomba_embrague: me.con_bomba_embrague,
          caja_transferencia: me.caja_transferencia,
          con_caja_transferencia: me.con_caja_transferencia,
          diferencial_trasero: me.diferencial_trasero,
          con_diferencial_trasero: me.con_diferencial_trasero,
          diferencial_delantero_4x4: me.diferencial_delantero_4x4,
          con_diferencial_delantero_4x4: me.con_diferencial_delantero_4x4,
          // 6 Direccion
          volante: me.volante,
          con_volante: me.con_volante,
          cana_direccion: me.cana_direccion,
          con_cana_direccion: me.con_cana_direccion,
          cremallera: me.cremallera,
          con_cremallera: me.con_cremallera,
          rotula: me.rotula,
          con_rotula: me.con_rotula,
          // 7 Suspension
          amortiguador_muelle: me.amortiguador_muelle,
          con_amortiguador_muelle: me.con_amortiguador_muelle,
          barra_torsion: me.barra_torsion,
          con_barra_torsion: me.con_barra_torsion,
          barra_estabilizadora: me.barra_estabilizadora,
          con_barra_estabilizadora: me.con_barra_estabilizadora,
          llanta: me.llanta,
          con_llanta: me.con_llanta,
          // 8 Carroceria
          capot_motor: me.capot_motor,
          con_capot_motor: me.con_capot_motor,
          capot_maletera: me.capot_maletera,
          con_capot_maletera: me.con_capot_maletera,
          parachoque_delatero: me.parachoque_delatero,
          con_parachoque_delatero: me.con_parachoque_delatero,
          parachoque_posterior: me.parachoque_posterior,
          con_parachoque_posterior: me.con_parachoque_posterior,
          luna_lateral: me.luna_lateral,
          con_luna_lateral: me.con_luna_lateral,
          luna_cortaviento: me.luna_cortaviento,
          con_luna_cortaviento: me.con_luna_cortaviento,
          parabrisa_delantero: me.parabrisa_delantero,
          con_parabrisa_delantero: me.con_parabrisa_delantero,
          parabrisa_posterior: me.parabrisa_posterior,
          con_parabrisa_posterior: me.con_parabrisa_posterior,
          tanque_combustible: me.tanque_combustible,
          con_tanque_combustible: me.con_tanque_combustible,
          puerta: me.puerta,
          con_puerta: me.con_puerta,
          asiento: me.asiento,
          con_asiento: me.con_asiento,
          // 9 Accesorios
          aire_acondicionado: me.aire_acondicionado,
          con_aire_acondicionado: me.con_aire_acondicionado,
          alarma: me.alarma,
          con_alarma: me.con_alarma,
          plumilla: me.plumilla,
          con_plumilla: me.con_plumilla,
          espejo: me.espejo,
          con_espejo: me.con_espejo,
          cinturon_seguridad: me.cinturon_seguridad,
          con_cinturon_seguridad: me.con_cinturon_seguridad,
          antena: me.antena,
          con_antena: me.con_antena,
          // 10 Otras Caracteristicas relevantes
          otra_caracteristica_relevante: me.otra_caracteristica_relevante,
          apreciacion_tecnica_general: me.apreciacion_tecnica_general
        })
          .then(function (response) {
            me.desabilitarDetVeh = false;
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            me.closeDetVehiculo();
          })
          .catch(function (error) {
            me.desabilitarDetVeh = false;
            me.mensajeBien = error.response.data;
            me.limpiarAlertaError();
          });
      } else { //Código para guardar
        axios.post("api/DetallesVehiculos/Crear", {
          idbien: me.idbien,
          // 1 Motor
          cilindro: me.cilindro,
          con_cilindro: me.con_cilindro,
          carburador_carter: me.carburador_carter,
          con_carburador_carter: me.con_carburador_carter,
          distribuidor_bomba_inyeccion: me.distribuidor_bomba_inyeccion,
          con_distribuidor_bomba_inyeccion: me.con_distribuidor_bomba_inyeccion,
          bomba_gasolina: me.bomba_gasolina,
          con_bomba_gasolina: me.con_bomba_gasolina,
          purificador_aire: me.purificador_aire,
          con_purificador_aire: me.con_purificador_aire,
          // 2 Frenos
          bomba_freno: me.bomba_freno,
          con_bomba_freno: me.con_bomba_freno,
          zapata_tambor: me.zapata_tambor,
          con_zapata_tambor: me.con_zapata_tambor,
          disco_pastilla: me.disco_pastilla,
          con_disco_pastilla: me.con_disco_pastilla,
          // 3 Refrigeracion
          radiador: me.radiador,
          con_radiador: me.con_radiador,
          ventilador: me.ventilador,
          con_ventilador: me.con_ventilador,
          bomba_agua: me.bomba_agua,
          con_bomba_agua: me.con_bomba_agua,
          // 4 Electrico
          motor_arranque: me.motor_arranque,
          con_motor_arranque: me.con_motor_arranque,
          bateria: me.bateria,
          con_bateria: me.con_bateria,
          alternador: me.alternador,
          con_alternador: me.con_alternador,
          bobina: me.bobina,
          con_bobina: me.con_bobina,
          relay_alternador: me.relay_alternador,
          con_relay_alternador: me.con_relay_alternador,
          faro_delantero: me.faro_delantero,
          con_faro_delantero: me.con_faro_delantero,
          direccional_delantero: me.direccional_delantero,
          con_direccional_delantero: me.con_direccional_delantero,
          direccional_posterior: me.direccional_posterior,
          con_direccional_posterior: me.con_direccional_posterior,
          luz_posterior: me.luz_posterior,
          con_luz_posterior: me.con_luz_posterior,
          auto_radio: me.auto_radio,
          con_auto_radio: me.con_auto_radio,
          parlante: me.parlante,
          con_parlante: me.con_parlante,
          claxon: me.claxon,
          con_claxon: me.con_claxon,
          circuito_luz: me.circuito_luz,
          con_circuito_luz: me.con_circuito_luz,
          // 5 Transmision
          caja_cambio: me.caja_cambio,
          con_caja_cambio: me.con_caja_cambio,
          bomba_embrague: me.bomba_embrague,
          con_bomba_embrague: me.con_bomba_embrague,
          caja_transferencia: me.caja_transferencia,
          con_caja_transferencia: me.con_caja_transferencia,
          diferencial_trasero: me.diferencial_trasero,
          con_diferencial_trasero: me.con_diferencial_trasero,
          diferencial_delantero_4x4: me.diferencial_delantero_4x4,
          con_diferencial_delantero_4x4: me.con_diferencial_delantero_4x4,
          // 6 Direccion
          volante: me.volante,
          con_volante: me.con_volante,
          cana_direccion: me.cana_direccion,
          con_cana_direccion: me.con_cana_direccion,
          cremallera: me.cremallera,
          con_cremallera: me.con_cremallera,
          rotula: me.rotula,
          con_rotula: me.con_rotula,
          // 7 Suspension
          amortiguador_muelle: me.amortiguador_muelle,
          con_amortiguador_muelle: me.con_amortiguador_muelle,
          barra_torsion: me.barra_torsion,
          con_barra_torsion: me.con_barra_torsion,
          barra_estabilizadora: me.barra_estabilizadora,
          con_barra_estabilizadora: me.con_barra_estabilizadora,
          llanta: me.llanta,
          con_llanta: me.con_llanta,
          // 8 Carroceria
          capot_motor: me.capot_motor,
          con_capot_motor: me.con_capot_motor,
          capot_maletera: me.capot_maletera,
          con_capot_maletera: me.con_capot_maletera,
          parachoque_delatero: me.parachoque_delatero,
          con_parachoque_delatero: me.con_parachoque_delatero,
          parachoque_posterior: me.parachoque_posterior,
          con_parachoque_posterior: me.con_parachoque_posterior,
          luna_lateral: me.luna_lateral,
          con_luna_lateral: me.con_luna_lateral,
          luna_cortaviento: me.luna_cortaviento,
          con_luna_cortaviento: me.con_luna_cortaviento,
          parabrisa_delantero: me.parabrisa_delantero,
          con_parabrisa_delantero: me.con_parabrisa_delantero,
          parabrisa_posterior: me.parabrisa_posterior,
          con_parabrisa_posterior: me.con_parabrisa_posterior,
          tanque_combustible: me.tanque_combustible,
          con_tanque_combustible: me.con_tanque_combustible,
          puerta: me.puerta,
          con_puerta: me.con_puerta,
          asiento: me.asiento,
          con_asiento: me.con_asiento,
          // 9 Accesorios
          aire_acondicionado: me.aire_acondicionado,
          con_aire_acondicionado: me.con_aire_acondicionado,
          alarma: me.alarma,
          con_alarma: me.con_alarma,
          plumilla: me.plumilla,
          con_plumilla: me.con_plumilla,
          espejo: me.espejo,
          con_espejo: me.con_espejo,
          cinturon_seguridad: me.cinturon_seguridad,
          con_cinturon_seguridad: me.con_cinturon_seguridad,
          antena: me.antena,
          con_antena: me.con_antena,
          // 10 Otras Caracteristicas relevantes
          otra_caracteristica_relevante: me.otra_caracteristica_relevante,
          apreciacion_tecnica_general: me.apreciacion_tecnica_general
        })
          .then(function (response) {
            me.desabilitarDetVeh = false;
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            me.closeDetVehiculo();
          })
          .catch(function (error) {
            me.desabilitarDetVeh = false;
            me.mensajeBien = error.response.data;
            me.limpiarAlertaError();
          });
      }
    },

    async editarDetalleVehiculo(id) {
      // Ventana EDITAR
      this.verDetVehiculo = true;
      this.editedIndexDetVeh = 1;
      await this.listarDetalleVehiculo(id);
    },

    async listarDetalleVehiculo(id) {
      let me = this;
      var data = [];

      var response = await axios.get("api/DetallesVehiculos/DetalleVehiculoBien/" + id)
        .then(function (response) {
          data = response.data; // Array de data
          // 1 Motor
          me.cilindro = data.cilindro;
          me.con_cilindro = data.con_cilindro;
          me.carburador_carter = data.carburador_carter;
          me.con_carburador_carter = data.con_carburador_carter;
          me.distribuidor_bomba_inyeccion = data.distribuidor_bomba_inyeccion;
          me.con_distribuidor_bomba_inyeccion = data.con_distribuidor_bomba_inyeccion;
          me.bomba_gasolina = data.bomba_gasolina;
          me.con_bomba_gasolina = data.con_bomba_gasolina;
          me.purificador_aire = data.purificador_aire;
          me.con_purificador_aire = data.con_purificador_aire;
          // 2 Frenos
          me.bomba_freno = data.bomba_freno;
          me.con_bomba_freno = data.con_bomba_freno;
          me.zapata_tambor = data.zapata_tambor;
          me.con_zapata_tambor = data.con_zapata_tambor;
          me.disco_pastilla = data.disco_pastilla;
          me.con_disco_pastilla = data.con_disco_pastilla;
          // 3 Refrigeracion
          me.radiador = data.radiador;
          me.con_radiador = data.con_radiador;
          me.ventilador = data.ventilador;
          me.con_ventilador = data.con_ventilador;
          me.bomba_agua = data.bomba_agua;
          me.con_bomba_agua = data.con_bomba_agua;
          // 4 Electrico
          me.motor_arranque = data.motor_arranque;
          me.con_motor_arranque = data.con_motor_arranque;
          me.bateria = data.bateria;
          me.con_bateria = data.con_bateria;
          me.alternador = data.alternador;
          me.con_alternador = data.con_alternador;
          me.bobina = data.bobina;
          me.con_bobina = data.con_bobina;
          me.relay_alternador = data.relay_alternador;
          me.con_relay_alternador = data.con_relay_alternador;
          me.faro_delantero = data.faro_delantero;
          me.con_faro_delantero = data.con_faro_delantero;
          me.direccional_delantero = data.direccional_delantero;
          me.con_direccional_delantero = data.con_direccional_delantero;
          me.direccional_posterior = data.direccional_posterior;
          me.con_direccional_posterior = data.con_direccional_posterior;
          me.luz_posterior = data.luz_posterior;
          me.con_luz_posterior = data.con_luz_posterior;
          me.auto_radio = data.auto_radio;
          me.con_auto_radio = data.con_auto_radio;
          me.parlante = data.parlante;
          me.con_parlante = data.con_parlante;
          me.claxon = data.claxon;
          me.con_claxon = data.con_claxon;
          me.circuito_luz = data.circuito_luz;
          me.con_circuito_luz = data.con_circuito_luz;
          // 5 Transmision
          me.caja_cambio = data.caja_cambio;
          me.con_caja_cambio = data.con_caja_cambio;
          me.bomba_embrague = data.bomba_embrague;
          me.con_bomba_embrague = data.con_bomba_embrague;
          me.caja_transferencia = data.caja_transferencia;
          me.con_caja_transferencia = data.con_caja_transferencia;
          me.diferencial_trasero = data.diferencial_trasero;
          me.con_diferencial_trasero = data.con_diferencial_trasero;
          me.diferencial_delantero_4x4 = data.diferencial_delantero_4x4;
          me.con_diferencial_delantero_4x4 = data.con_diferencial_delantero_4x4;
          // 6 Direccion
          me.volante = data.volante;
          me.con_volante = data.con_volante;
          me.cana_direccion = data.cana_direccion;
          me.con_cana_direccion = data.con_cana_direccion;
          me.cremallera = data.cremallera;
          me.con_cremallera = data.con_cremallera;
          me.rotula = data.rotula;
          me.con_rotula = data.con_rotula;
          // 7 Suspension
          me.amortiguador_muelle = data.amortiguador_muelle;
          me.con_amortiguador_muelle = data.con_amortiguador_muelle;
          me.barra_torsion = data.barra_torsion;
          me.con_barra_torsion = data.con_barra_torsion;
          me.barra_estabilizadora = data.barra_estabilizadora;
          me.con_barra_estabilizadora = data.con_barra_estabilizadora;
          me.llanta = data.llanta;
          me.con_llanta = data.con_llanta;
          // 8 Carroceria
          me.capot_motor = data.capot_motor;
          me.con_capot_motor = data.con_capot_motor;
          me.capot_maletera = data.capot_maletera;
          me.con_capot_maletera = data.con_capot_maletera;
          me.parachoque_delatero = data.parachoque_delatero;
          me.con_parachoque_delatero = data.con_parachoque_delatero;
          me.parachoque_posterior = data.parachoque_posterior;
          me.con_parachoque_posterior = data.con_parachoque_posterior;
          me.luna_lateral = data.luna_lateral;
          me.con_luna_lateral = data.con_luna_lateral;
          me.luna_cortaviento = data.luna_cortaviento;
          me.con_luna_cortaviento = data.con_luna_cortaviento;
          me.parabrisa_delantero = data.parabrisa_delantero;
          me.con_parabrisa_delantero = data.con_parabrisa_delantero;
          me.parabrisa_posterior = data.parabrisa_posterior;
          me.con_parabrisa_posterior = data.con_parabrisa_posterior;
          me.tanque_combustible = data.tanque_combustible;
          me.con_tanque_combustible = data.con_tanque_combustible;
          me.puerta = data.puerta;
          me.con_puerta = data.con_puerta;
          me.asiento = data.asiento;
          me.con_asiento = data.con_asiento;
          // 9 Accesorios
          me.aire_acondicionado = data.aire_acondicionado;
          me.con_aire_acondicionado = data.con_aire_acondicionado;
          me.alarma = data.alarma;
          me.con_alarma = data.con_alarma;
          me.plumilla = data.plumilla;
          me.con_plumilla = data.con_plumilla;
          me.espejo = data.espejo;
          me.con_espejo = data.con_espejo;
          me.cinturon_seguridad = data.cinturon_seguridad;
          me.con_cinturon_seguridad = data.con_cinturon_seguridad;
          me.antena = data.antena;
          me.con_antena = data.con_antena;
          // 10 Otras Caracteristicas relevantes
          me.otra_caracteristica_relevante = data.otra_caracteristica_relevante;
          me.apreciacion_tecnica_general = data.apreciacion_tecnica_general;

        })
        .catch(function (error) {
          // Ventana CREAR
          if (me.verBienModalImp == 0) { // Solo mostramos la ventana Crear si cumple la condicion
            me.verDetVehiculo = true;
            me.editedIndexDetVeh = -1;
          }
        });
    },

    closeDetVehiculo() {
      this.verDetVehiculo = false;
      this.editedIndexDetVeh = -1;

      // 1 Motor
      this.cilindro = "";
      this.con_cilindro = "NO";
      this.carburador_carter = "";
      this.con_carburador_carter = "NO";
      this.distribuidor_bomba_inyeccion = "";
      this.con_distribuidor_bomba_inyeccion = "NO";
      this.bomba_gasolina = "";
      this.con_bomba_gasolina = "NO";
      this.purificador_aire = "";
      this.con_purificador_aire = "NO";
      // 2 Frenos
      this.bomba_freno = "";
      this.con_bomba_freno = "NO";
      this.zapata_tambor = "";
      this.con_zapata_tambor = "NO";
      this.disco_pastilla = "";
      this.con_disco_pastilla = "NO";
      // 3 Refrigeracion
      this.radiador = "";
      this.con_radiador = "NO";
      this.ventilador = "";
      this.con_ventilador = "NO";
      this.bomba_agua = "";
      this.con_bomba_agua = "NO";
      // 4 Electrico
      this.motor_arranque = "";
      this.con_motor_arranque = "NO";
      this.bateria = "";
      this.con_bateria = "NO";
      this.alternador = "";
      this.con_alternador = "NO";
      this.bobina = "";
      this.con_bobina = "NO";
      this.relay_alternador = "";
      this.con_relay_alternador = "NO";
      this.faro_delantero = "";
      this.con_faro_delantero = "NO";
      this.direccional_delantero = "";
      this.con_direccional_delantero = "NO";
      this.direccional_posterior = "";
      this.con_direccional_posterior = "NO";
      this.luz_posterior = "";
      this.con_luz_posterior = "NO";
      this.auto_radio = "";
      this.con_auto_radio = "NO";
      this.parlante = "";
      this.con_parlante = "NO";
      this.claxon = "";
      this.con_claxon = "NO";
      this.circuito_luz = "";
      this.con_circuito_luz = "NO";
      // 5 Transmision
      this.caja_cambio = "";
      this.con_caja_cambio = "NO";
      this.bomba_embrague = "";
      this.con_bomba_embrague = "NO";
      this.caja_transferencia = "";
      this.con_caja_transferencia = "NO";
      this.diferencial_trasero = "";
      this.con_diferencial_trasero = "NO";
      this.diferencial_delantero_4x4 = "";
      this.con_diferencial_delantero_4x4 = "NO";
      // 6 Direccion
      this.volante = "";
      this.con_volante = "NO";
      this.cana_direccion = "";
      this.con_cana_direccion = "NO";
      this.cremallera = "";
      this.con_cremallera = "NO";
      this.rotula = "";
      this.con_rotula = "NO";
      // 7 Suspension
      this.amortiguador_muelle = "";
      this.con_amortiguador_muelle = "NO";
      this.barra_torsion = "";
      this.con_barra_torsion = "NO";
      this.barra_estabilizadora = "";
      this.con_barra_estabilizadora = "NO";
      this.llanta = "";
      this.con_llanta = "NO";
      // 8 Carroceria
      this.capot_motor = "";
      this.con_capot_motor = "NO";
      this.capot_maletera = "";
      this.con_capot_maletera = "NO";
      this.parachoque_delatero = "";
      this.con_parachoque_delatero = "NO";
      this.parachoque_posterior = "";
      this.con_parachoque_posterior = "NO";
      this.luna_lateral = "";
      this.con_luna_lateral = "NO";
      this.luna_cortaviento = "";
      this.con_luna_cortaviento = "NO";
      this.parabrisa_delantero = "";
      this.con_parabrisa_delantero = "NO";
      this.parabrisa_posterior = "";
      this.con_parabrisa_posterior = "NO";
      this.tanque_combustible = "";
      this.con_tanque_combustible = "NO";
      this.puerta = "";
      this.con_puerta = "NO";
      this.asiento = "";
      this.con_asiento = "NO";
      // 9 Accesorios
      this.aire_acondicionado = "";
      this.con_aire_acondicionado = "NO";
      this.alarma = "";
      this.con_alarma = "NO";
      this.plumilla = "";
      this.con_plumilla = "NO";
      this.espejo = "";
      this.con_espejo = "NO";
      this.cinturon_seguridad = "";
      this.con_cinturon_seguridad = "NO";
      this.antena = "";
      this.con_antena = "NO";
      // 10 Otras Caracteristicas relevantes
      this.otra_caracteristica_relevante = "";
      this.apreciacion_tecnica_general = "";
    },

    ocultarBienImp() {
      this.verBienModalImp = 0;
      this.limpiar();
    },

    async mostrarBienVehImp(item) {
      await this.listarDetalleVehiculo(item.idbien);
      // Datos Cabecera
      this.nomareas = item.nomareas;
      this.pnombres = item.pnombres;
      this.codbien = item.codbien;
      this.tbdescripcion = item.tbdescripcion;
      this.nummotor = item.nummotor;
      this.serie = item.serie;
      this.placa = item.placa;
      this.ano = item.ano;
      this.carroceria = item.carroceria;
      this.color = item.color;
      this.marca = item.marca;
      this.combustible = item.combustible;
      this.modelo = item.modelo;
      this.transmision = item.transmision;
      this.tipo = item.tipo;
      this.cilindrada = item.cilindrada;
      this.numchasis = item.numchasis;
      this.kilometraje = item.kilometraje;
      this.nro_ejes = item.nro_ejes;
      this.tarjeta_propiedad = item.tarjeta_propiedad;

      this.valordq = item.valordq;
      this.valorlibro = item.valorlibro;

      // Imagenes
      this.imagen = item.imagen;
      this.imagen2 = item.imagen2;
      this.imagen3 = item.imagen3;

      //Ventana impresion
      this.verBienModalImp = 2;
      this.crearPDFVeh(item.idbien);
    },
    //#endregion Detalle Vehiculo

    //#region Depreciacion
    async generarDepreciacion(fechaInicio, fechaFin, montoInicial, porcentajeAnual, valorResidual) {
      const resultado = [];
      let depreciacionAcumulada = 0;
      const depreciacionAnual = montoInicial * porcentajeAnual;

      let inicio = new Date(fechaInicio);
      const finTotal = new Date(fechaFin);
      let anio = 1;

      while ((montoInicial - depreciacionAcumulada > valorResidual) && (inicio < finTotal)) {
        let fin = new Date(inicio);
        fin.setFullYear(fin.getFullYear() + 1);

        if (fin > finTotal) {
          fin = new Date(finTotal); // limitar el último año al máximo permitido
        }

        const restante = montoInicial - depreciacionAcumulada;
        const depreciacion = Math.min(depreciacionAnual, restante - valorResidual);

        depreciacionAcumulada += depreciacion;

        resultado.push({
          anioCumplido: anio,
          desde: inicio.toISOString().split('T')[0],
          hasta: fin.toISOString().split('T')[0],
          depreciacionAnual: depreciacion.toFixed(2),
          acumulado: depreciacionAcumulada.toFixed(2),
          valorRestante: (montoInicial - depreciacionAcumulada).toFixed(2)
        });

        inicio = fin;
        anio++;
      }

      return resultado;
    },

    async crearXlsxDepreciacion(item) {
      const fechaInicio = new Date(item.fec_reg);
      const fechaFin = new Date();

      var data = await this.generarDepreciacion(fechaInicio, fechaFin, item.valordq, item.depreciacion, 1)

      // Estilo para el título principal
      const titleStyle = {
        font: { name: 'Calibri', size: 16, bold: true, color: { argb: 'FF000000' } },
        alignment: { vertical: 'middle', horizontal: 'center' }
      };

      // Estilo para las etiquetas de la información del activo (ej: "Código SBN")
      const headerLabelStyle = {
        font: { name: 'Calibri', bold: true, color: { argb: 'FF000000' } },
        alignment: { horizontal: 'right' },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFDE9D9' } }, // Color anaranjado claro
      };

      // Estilo para las cabeceras de la tabla de depreciación
      const tableHeaderStyle = {
        font: { name: 'Calibri', bold: true, color: { argb: 'FF000000' } },
        alignment: { vertical: 'middle', horizontal: 'center' },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFC6E0B4' } }, // Color verde claro
      };

      // 1. Crear un nuevo libro y una hoja de cálculo
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Depreciación');

      // Crear una imagen de base64
      const Base64 = 'data:image/png;base64,' + this.empresaState.logo;
      const logoImage = workbook.addImage({
        base64: Base64,
        extension: 'jpeg',
      });

      // Agregar la imagen a la hoja de cálculo
      worksheet.addImage(logoImage, {
        ext: { width: 50, height: 65 },
      });

      // 2. Definir el ancho de las columnas para que se ajusten al contenido
      worksheet.getColumn('A').width = 7;
      worksheet.getColumn('B').width = 18;
      worksheet.getColumn('C').width = 17;
      worksheet.getColumn('D').width = 15;
      worksheet.getColumn('E').width = 15;
      worksheet.getColumn('F').width = 15;

      // 3. Añadir el título principal y combinar celdas
      worksheet.addRow(['CUADRO DE DEPRECIACIÓN ANUAL']);
      worksheet.mergeCells('A1:F1');
      worksheet.getCell('A1').style = titleStyle;
      worksheet.getRow(1).height = 25;

      // 4. Añadir la información del activo (filas 3 a 8)
      const assetInfo = [
        ['', 'Entidad:', this.empresaState.nombre],
        ['', 'Código SBN:', item.codbien.length == '12' ? item.codbien : item.codbienint + '-' + item.codinterno],
        ['', 'Descripción:', item.tbdescripcion],
        ['', 'Fecha de Adquisición:', moment(item.fec_reg).format("DD/MM/YYYY")],
        ['', 'Fecha de Cálculo:', item.fechacalculoact],
        ['', 'Valor de Compra:', Number(item.valordq)],
        ['', '% Depreciacion:', item.depreciacion * 100 + "%"],
        ['', 'Vida Util:', item.vidautil + ' AÑOS']
      ];

      assetInfo.forEach((rowData, index) => {
        const row = worksheet.addRow(rowData);

        // Aplicar estilos
        const labelCell = row.getCell(2);
        labelCell.style = headerLabelStyle;

        // Aplicar formato solo a "Valor de Compra"
        if (index === 5) {
          const valueCell = row.getCell(3);
          valueCell.numFmt = '"S/ "#,##0.00';
          valueCell.alignment = { horizontal: 'left' };
          valueCell.font = { name: 'Calibri', size: 11 };
        }
      });


      // 5. Añadir un espacio y la cabecera de la tabla de depreciación
      worksheet.addRow([]); // Fila 9 vacía
      const headerRow = worksheet.addRow(['Año', 'Fecha Inicial', 'Fecha Final', 'Depreciación Anual', 'Acumulada', 'Valor Libros']);
      headerRow.eachCell(cell => {
        cell.style = tableHeaderStyle;
      });
      headerRow.height = 20;

      // 6. Añadir los datos de la tabla de depreciación
      data.forEach(rowData => {
        const row = worksheet.addRow([
          rowData.anioCumplido,
          moment(rowData.desde).format("DD/MM/YYYY"),
          moment(rowData.hasta).format("DD/MM/YYYY"),
          Number(rowData.depreciacionAnual),
          Number(rowData.acumulado),
          Number(rowData.valorRestante)
        ]);

        // Aplicar estilos y bordes
        for (let col = 1; col <= 6; col++) {
          const cell = row.getCell(col);

          // Borde verde alrededor de la celda
          cell.border = {
            top: { style: 'thin', color: { argb: 'FFC6E0B4' } },
            left: { style: 'thin', color: { argb: 'FFC6E0B4' } },
            bottom: { style: 'thin', color: { argb: 'FFC6E0B4' } },
            right: { style: 'thin', color: { argb: 'FFC6E0B4' } },
          };
        }

        // Centrar la celda del año (columna A = índice 1)
        [1, 2, 3].forEach(col => {
          row.getCell(col).alignment = { horizontal: 'center' };
        });
        // Formato y estilo para columnas 5 y 6
        [4, 5, 6].forEach(col => {
          const cell = row.getCell(col);
          cell.numFmt = '#,##0.00'; // incluye símbolo de soles
          cell.alignment = { horizontal: 'right' };
          cell.font = { name: 'Calibri', size: 11 };
        });
      });

      // Ocultar las líneas de división de la hoja de cálculo
      worksheet.views = [
        {
          showGridLines: false
        }
      ];

      // 7. Generar el archivo y descargarlo
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Cuadro Depreciacion ' + (item.codbien.length === 12 ? item.codbien : item.codbienint + '-' + item.codinterno) + '.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    //#endregion Depreciacion

    /* Crear PDF bien */
    crearPDF() {
      let me = this;

      var doc = new jsPDF("p", "mm", [210, 297]);
      // Titulo
      // Logotipo jala de la empresa a la que se accedio
      var imgData = "data:image/png;base64," + this.empresaState.logo;
      doc.addImage(imgData, "JPEG", 20, 9, 13, 16); // Logo

      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
      doc.text("FICHA DE DATOS - BIENES ACTIVOS", doc.internal.pageSize.width / 2, 18, { align: "center" });
      // Fin Titulo

      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.text(20, 30, "EMPRESA: " + me.empresaState.nombre);

      // Descripcion y codigo bien
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.text(20, 40, "DENOMINACIÓN");
      doc.setFont("helvetica", "bold");
      doc.roundedRect(20, 42, 140, 4, 1, 1);
      doc.text(23, 45, me.tbdescripcion);
      doc.setFont("helvetica", "normal");
      doc.text(171, 40, "CODIGO BIEN");
      doc.setFont("helvetica", "bold");
      doc.roundedRect(170, 42, 22, 4, 1, 1);
      doc.text(172, 45, me.codbien.length == 12 ? me.codbien : me.codbienint + "-" + me.codinterno);
      // Fin  Descripcion y codigo bien

      // Detalle de Bien
      doc.roundedRect(20, 50, 172, 165, 1, 1);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(23, 55, "UBICACIÓN");
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.text(25, 60, "LOCAL: " + me.nomlocales);
      doc.text(25, 65, "AREA: " + me.nomareas);

      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(23, 70, "PERSONAL");
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.text(25, 75, "NOMBRE: " + me.pnombres);
      doc.text(150, 75, "DNI: " + me.pnrodoc);

      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(23, 80, "DATOS GENERALES");
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      doc.text(25, 85, "CUENTA: " + me.cuenta);
      doc.text(100, 85, "VALOR: " + numeral(me.valordq).format("###,##0.00"));

      // Estado
      var estado = "";
      for (var i = 0; i < me.cm.flg_estados.length; i++) {
        estado = estado + (me.cm.flg_estados[i].value == me.flg_estado ? me.cm.flg_estados[i].text : "");
      }
      doc.text(150, 85, "ESTADO: " + estado);
      // Fin Estado

      // Condicion
      var cond = "";
      for (var i = 0; i < me.cm.flg_conds.length; i++) {
        cond = cond + (me.cm.flg_conds[i].value == me.flg_cond ? me.cm.flg_conds[i].text : "");
      }
      doc.text(25, 90, "FORMA ADQUISICIÓN: " + cond);
      // Fin Condicion

      doc.text(100, 90, "FECHA ADQUISICIÓN: " + moment(me.fec_reg).format("DD/MM/YYYY"));
      doc.text(150, 90, "SITUACIÓN: " + (me.situacion == "U" ? "USO" : me.situacion == "D" ? "DESUSO" : "FALTANTE"));
      doc.text(25, 95, "DOCUMENTO ADQ.: " + me.doc_alta);
      doc.text(150, 95, "ASEGURADO: " + (me.asegurado == "S" ? "SI" : "NO"));

      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(23, 100, "DETALLE TECNICO");
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);

      let valText = 105;

      doc.text(25, valText, "MARCA: " + me.marca);
      doc.text(70, valText, "MODELO: " + me.modelo);
      doc.text(110, valText, "TIPO: " + me.tipo);
      doc.text(155, valText, "COLOR: " + me.color);

      valText = valText + 5;

      doc.text(25, valText, "SERIE: " + me.serie);
      doc.text(70, valText, "DIMENSIÓN: " + me.dimension);
      //  NO VISUALIZAMOS SI ES 82,04,36
      if (me.codtipobien == null ? false : me.codtipobien.substring(2, 4) == "82" ? true : me.codtipobien.substring(2, 4) == "04" ? true : me.codtipobien.substring(2, 4) == "36") {
        doc.text(110, valText, "PLACA: " + me.placa);
        doc.text(155, valText, "AÑO: " + me.ano);
        valText = valText + 5;
        doc.text(25, valText, "Nº MOTOR: " + me.nummotor);
        doc.text(70, valText, "Nº CHASIS: " + me.numchasis);
        doc.text(130, valText, "CARROCERIA: " + me.carroceria);
        valText = valText + 5;
        doc.text(25, valText, "NRO. EJES: " + me.nro_ejes);
        doc.text(70, valText, "COMBUSTIBLE: " + me.combustible);
        doc.text(130, valText, "TRANSMISIÓN: " + me.transmision);
        valText = valText + 5;
        doc.text(25, valText, "CILINDRADA: " + me.cilindrada);
        doc.text(70, valText, "KILOMETRAJE: " + me.kilometraje);
        doc.text(130, valText, "TARJ. PROPIEDAD: " + me.tarjeta_propiedad);
      }

      doc.autoTable({
        theme: "plain",
        margin: { left: 24, right: 24, top: valText = valText + 3 },
        bodyStyles: {
          cellPadding: 1,
          font: "helvetica",
          fontStyle: "normal",
          fontSize: 7,
        },
        body: [
          [{ content: "OTRAS CARACTERISTICAS: " + me.otras_caract }],
          [{ content: "OBSERVACIÓN: " + me.observacion }],
        ],
      });

      let finalY = doc.lastAutoTable.finalY;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(23, finalY = finalY + 5, "IMAGEN");
      // IMAGENES
      var imgBien = "data:image/png;base64," + (me.imagen == null || me.imagen == '' ? me.imagenxdefec : me.imagen);
      var imgBien2 = "data:image/png;base64," + (me.imagen2 == null || me.imagen2 == '' ? me.imagenxdefec : me.imagen2);
      var imgBien3 = "data:image/png;base64," + (me.imagen3 == null || me.imagen3 == '' ? me.imagenxdefec : me.imagen3);
      var pageWidth = 210; // Ancho de la hoja en mm

      var imgWidth = 50; // Ancho
      var imgHeight = 50; // Altura
      var imgMargin = 5; // Margen entre las imágenes y los bordes de la página

      // Calcular la posición horizontal para las imágenes
      var startX1 = (pageWidth - imgWidth * 3 - imgMargin * 2) / 2;
      var startX2 = startX1 + imgWidth + imgMargin;
      var startX3 = startX2 + imgWidth + imgMargin;

      // Calcular la posición vertical para las imágenes
      var startY = finalY + 10;

      // Agregar las imágenes al documento con las nuevas posiciones
      doc.addImage(imgBien, "JPEG", startX1, startY, imgWidth, imgHeight);
      doc.addImage(imgBien2, "JPEG", startX2, startY, imgWidth, imgHeight);
      doc.addImage(imgBien3, "JPEG", startX3, startY, imgWidth, imgHeight);
      // Fin Detalle de Bien

      // Firmas
      var line = startY + 100;
      var linlong = 50;
      var linMargin = 10;

      var startL1 = (pageWidth - linlong * 3 - linMargin * 2) / 2;
      var startL2 = startL1 + linlong + linMargin;
      var startL3 = startL2 + linlong + linMargin;

      doc.line(startL1, line, startL1 + linlong, line);
      doc.text(startL1 + 10, line + 4, "Responsable de la OCP");

      doc.line(startL2, line, startL2 + linlong, line);
      doc.text(startL2 + 16, line + 4, "Área Usuaria");

      doc.line(startL3, line, startL3 + linlong, line);
      doc.text(startL3 + 12, line + 4, "Registro SIME OCP");

      // Exportar
      me.stringPdf = doc.output("datauristring");
      me.blobPdf = doc.output("blob");
      // Para visualizar todas las paginas del pdf
      this.srcPdf = pdf.createLoadingTask(this.stringPdf);
      this.srcPdf.promise.then((pdf) => {
        this.numPages = pdf.numPages;
      });
    },

    async crearPDFVeh() {
      let me = this;

      var bodyStyles = {
        cellPadding: 0.3,
        font: "helvetica",
        fontStyle: "normal",
        fontSize: 5.5,
        textColor: 0,
        lineColor: 0,
        lineWidth: 0.2,
      };

      // Agregar Encabezado: titulo y logo
      const addHeaders = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.addImage(imgDataG, "JPEG", 15, 10, 35.74, 7); // Logo gobierno
          doc.addImage(imgData, "JPEG", 188, 10, 5.5, 7); // Logo empresa
          doc.setFont("helvetica", "bold");
          doc.setFontSize(7);
          doc.text("ANEXO Nº 8", pageWidth / 2, 14, { align: "center" });
          doc.text("FORMATO DE FICHA TÉCNICA DEL VEHÍCULO", pageWidth / 2, 18, { align: "center" });
          doc.setFont("helvetica", "normal");
          doc.setFontSize(5);
          doc.text("Pag. " + i + " de " + pageCount, 170, 15);
          doc.setFont("helvetica", "bold");
          doc.text("Fecha: " + me.cm.formatFecha(me.fechaActual), 170, 18);
        }
      };

      var imgData = "data:image/png;base64," + this.empresaState.logo;
      var imgDataG = "data:image/png;base64,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";

      var doc = new jsPDF("p", "mm", [210, 297]);
      // Cabecera
      doc.autoTable({
        theme: "grid",
        startY: 20,
        margin: { left: 15, right: 15 },
        styles: { overflow: "ellipsize", cellWidth: "wrap" },
        bodyStyles,
        body: [
          [{ "content": "FICHA TÉCNICA DEL VEHÍCULO", colSpan: 4, styles: { fontStyle: "bold", halign: "center", fillColor: [190, 190, 190] } }],
          [{ "content": "ENTIDAD", styles: { fontStyle: "bold", cellWidth: 30 } }, { "content": me.empresaState.nombre, colSpan: 3, styles: { fontStyle: "bold" } }],
          [{ "content": "ÁREA RESPONSABLE", styles: { fontStyle: "bold" } }, { "content": me.nomareas, styles: { cellWidth: 60 } }, { "content": "NOMBRE", styles: { fontStyle: "bold", cellWidth: 30 } }, { "content": me.pnombres, styles: { cellWidth: 60 } }],
          [{ "content": "COD. PATRIMONIAL", styles: { fontStyle: "bold" } }, { "content": me.codbien, styles: { fontStyle: "bold" } }, { "content": "Nº DE MOTOR", styles: { fontStyle: "bold" } }, { "content": me.nummotor }],
          [{ "content": "DENOMINACIÓN", styles: { fontStyle: "bold" } }, { "content": me.tbdescripcion }, { "content": "Nº DE SERIE", styles: { fontStyle: "bold" } }, { "content": me.serie }],
          [{ "content": "PLACA", styles: { fontStyle: "bold" } }, { "content": me.placa }, { "content": "AÑO DE FABRICACÓN", styles: { fontStyle: "bold" } }, { "content": me.ano }],
          [{ "content": "CARROCERIA", styles: { fontStyle: "bold" } }, { "content": me.carroceria }, { "content": "COLOR", styles: { fontStyle: "bold" } }, { "content": me.color }],
          [{ "content": "MARCA", styles: { fontStyle: "bold" } }, { "content": me.marca }, { "content": "COMBUSTIBLE", styles: { fontStyle: "bold" } }, { "content": me.combustible }],
          [{ "content": "MODELO", styles: { fontStyle: "bold" } }, { "content": me.modelo }, { "content": "TRANSMISIÓN", styles: { fontStyle: "bold" } }, { "content": me.transmision }],
          [{ "content": "CATEGORIA", styles: { fontStyle: "bold" } }, { "content": me.tipo }, { "content": "CILINDRADA", styles: { fontStyle: "bold" } }, { "content": me.cilindrada }],
          [{ "content": "Nº DE CHASIS (VIN)", styles: { fontStyle: "bold" } }, { "content": me.numchasis }, { "content": "KILOMETRAJE", styles: { fontStyle: "bold" } }, { "content": me.kilometraje }],
          [{ "content": "Nº DE EJES", styles: { fontStyle: "bold" } }, { "content": me.nro_ejes }, { "content": "TARJETA DE PROPIEDAD", styles: { fontStyle: "bold" } }, { "content": me.tarjeta_propiedad }],
          [{ "content": "Valor neto (S/) " + numeral(me.valorlibro).format("###,##0.00"), colSpan: 4, styles: { fontStyle: "bold" } }],
        ],
      });
      // Detalles
      doc.autoTable({
        theme: "grid",
        startY: doc.lastAutoTable.finalY,
        margin: { left: 15, right: 15 },
        //styles: { overflow: "ellipsize", cellWidth: "wrap" },
        bodyStyles,
        body: [
          [{ "content": "DESCRIPCIÓN", styles: { fontStyle: "bold", halign: "center" } }, { "content": "APRECIACIÓN TECNICA", colSpan: 2, styles: { fontStyle: "bold", halign: "center" } }],

          [{ "content": "1. SISTEMA DE MOTOR", colSpan: 3, styles: { fontStyle: "bold", fillColor: [190, 190, 190] } }],
          [{ "content": "Cilindros", styles: { fontStyle: "bold", cellWidth: 40 } }, { "content": me.con_cilindro, styles: { fontStyle: "bold", halign: "center", cellWidth: 5 } }, { "content": me.cilindro, styles: { cellWidth: 135 } }],
          [{ "content": "Carburador / Carter", styles: { fontStyle: "bold" } }, { "content": me.con_carburador_carter, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.carburador_carter }],
          [{ "content": "Distribuidor / Bomba de inyección", styles: { fontStyle: "bold" } }, { "content": me.con_distribuidor_bomba_inyeccion, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.distribuidor_bomba_inyeccion }],
          [{ "content": "Bomba de gasolina", styles: { fontStyle: "bold" } }, { "content": me.con_bomba_gasolina, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.bomba_gasolina }],
          [{ "content": "Purificador de aire", styles: { fontStyle: "bold" } }, { "content": me.con_purificador_aire, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.purificador_aire }],

          [{ "content": "2. SISTEMA DE FRENOS", colSpan: 3, styles: { fontStyle: "bold", fillColor: [190, 190, 190] } }],
          [{ "content": "Bomba de frenos", styles: { fontStyle: "bold" } }, { "content": me.con_bomba_freno, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.bomba_freno }],
          [{ "content": "Zapatas y tambores", styles: { fontStyle: "bold" } }, { "content": me.con_zapata_tambor, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.zapata_tambor }],
          [{ "content": "Discos y pastillas", styles: { fontStyle: "bold" } }, { "content": me.con_disco_pastilla, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.disco_pastilla }],

          [{ "content": "3. SISTEMA DE REFRIGERACIÓN", colSpan: 3, styles: { fontStyle: "bold", fillColor: [190, 190, 190] } }],
          [{ "content": "Radiador", styles: { fontStyle: "bold" } }, { "content": me.con_radiador, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.radiador }],
          [{ "content": "Ventilador", styles: { fontStyle: "bold" } }, { "content": me.con_ventilador, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.ventilador }],
          [{ "content": "Bomba de agua", styles: { fontStyle: "bold" } }, { "content": me.con_bomba_agua, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.bomba_agua }],

          [{ "content": "4. SISTEMA ELÉCTRICO", colSpan: 3, styles: { fontStyle: "bold", fillColor: [190, 190, 190] } }],
          [{ "content": "Motor de arranque", styles: { fontStyle: "bold" } }, { "content": me.con_motor_arranque, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.motor_arranque }],
          [{ "content": "Bateria", styles: { fontStyle: "bold" } }, { "content": me.con_bateria, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.bateria }],
          [{ "content": "Alternador", styles: { fontStyle: "bold" } }, { "content": me.con_alternador, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.alternador }],
          [{ "content": "Bobina", styles: { fontStyle: "bold" } }, { "content": me.con_bobina, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.bobina }],
          [{ "content": "Relay de alternador", styles: { fontStyle: "bold" } }, { "content": me.con_relay_alternador, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.relay_alternador }],
          [{ "content": "Faros delanteros", styles: { fontStyle: "bold" } }, { "content": me.con_faro_delantero, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.faro_delantero }],
          [{ "content": "Direccionales delanteras", styles: { fontStyle: "bold" } }, { "content": me.con_direccional_delantero, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.direccional_delantero }],
          [{ "content": "Luces posteriores", styles: { fontStyle: "bold" } }, { "content": me.con_luz_posterior, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.luz_posterior }],
          [{ "content": "Direccionales posteriores", styles: { fontStyle: "bold" } }, { "content": me.con_direccional_posterior, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.direccional_posterior }],
          [{ "content": "Auto radio", styles: { fontStyle: "bold" } }, { "content": me.con_auto_radio, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.auto_radio }],
          [{ "content": "Parlantes", styles: { fontStyle: "bold" } }, { "content": me.con_parlante, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.parlante }],
          [{ "content": "Claxon", styles: { fontStyle: "bold" } }, { "content": me.con_claxon, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.claxon }],
          [{ "content": "Circuito de luces (faros cables)", styles: { fontStyle: "bold" } }, { "content": me.con_circuito_luz, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.circuito_luz }],

          [{ "content": "5. SISTEMA DE TRANSMISIÓN", colSpan: 3, styles: { fontStyle: "bold", fillColor: [190, 190, 190] } }],
          [{ "content": "Caja de cambios", styles: { fontStyle: "bold" } }, { "content": me.con_caja_cambio, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.caja_cambio }],
          [{ "content": "Bomba de embrague", styles: { fontStyle: "bold" } }, { "content": me.con_bomba_embrague, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.bomba_embrague }],
          [{ "content": "Caja de transferencia", styles: { fontStyle: "bold" } }, { "content": me.con_caja_transferencia, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.caja_transferencia }],
          [{ "content": "Diferencial trasero", styles: { fontStyle: "bold" } }, { "content": me.con_diferencial_trasero, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.diferencial_trasero }],
          [{ "content": "Diferencial delantero 4x4", styles: { fontStyle: "bold" } }, { "content": me.con_diferencial_delantero_4x4, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.diferencial_delantero_4x4 }],

          [{ "content": "6. SISTEMA DE DIRECCIÓN", colSpan: 3, styles: { fontStyle: "bold", fillColor: [190, 190, 190] } }],
          [{ "content": "Volante", styles: { fontStyle: "bold" } }, { "content": me.con_volante, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.volante }],
          [{ "content": "Caña de dirección", styles: { fontStyle: "bold" } }, { "content": me.con_cana_direccion, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.cana_direccion }],
          [{ "content": "Cremallera", styles: { fontStyle: "bold" } }, { "content": me.con_cremallera, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.cremallera }],
          [{ "content": "Rotulas", styles: { fontStyle: "bold" } }, { "content": me.con_rotula, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.rotula }],

          [{ "content": "7. SISTEMA DE SUSPENSIÓN", colSpan: 3, styles: { fontStyle: "bold", fillColor: [190, 190, 190] } }],
          [{ "content": "Amortiguadores / Muelles", styles: { fontStyle: "bold" } }, { "content": me.con_amortiguador_muelle, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.amortiguador_muelle }],
          [{ "content": "Barra de torsión", styles: { fontStyle: "bold" } }, { "content": me.con_barra_torsion, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.barra_torsion }],
          [{ "content": "Barra estabilizadora", styles: { fontStyle: "bold" } }, { "content": me.con_barra_estabilizadora, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.barra_estabilizadora }],
          [{ "content": "Llantas", styles: { fontStyle: "bold" } }, { "content": me.con_llanta, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.llanta }],

          [{ "content": "8. CARROCERIA", colSpan: 3, styles: { fontStyle: "bold", fillColor: [190, 190, 190] } }],
          [{ "content": "Capot de motor", styles: { fontStyle: "bold" } }, { "content": me.con_capot_motor, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.capot_motor }],
          [{ "content": "Capot de maletera", styles: { fontStyle: "bold" } }, { "content": me.con_capot_maletera, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.capot_maletera }],
          [{ "content": "Parachoques delanteos", styles: { fontStyle: "bold" } }, { "content": me.con_parachoque_delatero, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.parachoque_delatero }],
          [{ "content": "Parachoques posteriores", styles: { fontStyle: "bold" } }, { "content": me.con_parachoque_posterior, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.parachoque_posterior }],
          [{ "content": "Lunas laterales", styles: { fontStyle: "bold" } }, { "content": me.con_luna_lateral, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.luna_lateral }],
          [{ "content": "Lunas cortaviento", styles: { fontStyle: "bold" } }, { "content": me.con_luna_cortaviento, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.luna_cortaviento }],
          [{ "content": "Parabrisas delanteros", styles: { fontStyle: "bold" } }, { "content": me.con_parabrisa_delantero, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.parabrisa_delantero }],
          [{ "content": "Parabrisas posterior", styles: { fontStyle: "bold" } }, { "content": me.con_parabrisa_posterior, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.parabrisa_posterior }],
          [{ "content": "Tanque de conbustible", styles: { fontStyle: "bold" } }, { "content": me.con_tanque_combustible, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.tanque_combustible }],
          [{ "content": "Puertas ", styles: { fontStyle: "bold" } }, { "content": me.con_puerta, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.puerta }],
          [{ "content": "Asientos", styles: { fontStyle: "bold" } }, { "content": me.con_asiento, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.asiento }],

          [{ "content": "9. ACCESORIOS", colSpan: 3, styles: { fontStyle: "bold", fillColor: [190, 190, 190] } }],
          [{ "content": "Aire acondicionado", styles: { fontStyle: "bold" } }, { "content": me.con_aire_acondicionado, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.aire_acondicionado }],
          [{ "content": "Alarma", styles: { fontStyle: "bold" } }, { "content": me.con_alarma, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.alarma }],
          [{ "content": "Plumillas", styles: { fontStyle: "bold" } }, { "content": me.con_plumilla, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.plumilla }],
          [{ "content": "Espejos", styles: { fontStyle: "bold" } }, { "content": me.con_espejo, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.espejo }],
          [{ "content": "Cinturones de seguridad", styles: { fontStyle: "bold" } }, { "content": me.con_cinturon_seguridad, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.cinturon_seguridad }],
          [{ "content": "Antena", styles: { fontStyle: "bold" } }, { "content": me.con_antena, styles: { fontStyle: "bold", halign: "center" } }, { "content": me.antena }],

          [{ "content": "10. OTRAS CARACTERISTICAS RELEVANTES", colSpan: 3, styles: { fontStyle: "bold", fillColor: [190, 190, 190] } }],
          [{ "content": me.otra_caracteristica_relevante, colSpan: 3 }],

          [{ "content": "APRECIACIÓN TECNICA GENERAL(*)", colSpan: 3, styles: { fontStyle: "bold", fillColor: [190, 190, 190] } }],
          [{ "content": me.apreciacion_tecnica_general, colSpan: 3 }],
        ],
      });
      var pageWidth = doc.internal.pageSize.width; // Ancho de la hoja

      // Firmas
      doc.setFont("helvetica", "normal");
      doc.setFontSize(6);
      doc.setDrawColor(0, 0, 0);
      var line = 282;
      var linlong = 40;
      var linMargin = 5;

      if (me.usuarioState.seguimientoinv == 'SI') {
        var startL1 = (pageWidth - linlong * 3 - linMargin * 2) / 2;
        var startL2 = startL1 + linlong + linMargin;
        var startL3 = startL2 + linlong + linMargin;

        doc.line(startL1, line, startL1 + linlong, line);
        doc.text(startL1 + 14, 285, "Area Usuaria");

        doc.line(startL2, line, startL2 + linlong, line);
        doc.text(startL2 + 9, 285, "Mecánico o Especialista");

        doc.line(startL3, line, startL3 + linlong, line);
        doc.text(startL3 + 9, 285, "Personal Inventariador");
      } else {
        var startL1 = (pageWidth - linlong * 4 - linMargin * 3) / 2;
        var startL2 = startL1 + linlong + linMargin;
        var startL3 = startL2 + linlong + linMargin;
        var startL4 = startL3 + linlong + linMargin;

        doc.line(startL1, line, startL1 + linlong, line);
        doc.text(startL1 + 9, 285, "Responzable de la OCP");

        doc.line(startL2, line, startL2 + linlong, line);
        doc.text(startL2 + 14, 285, "Area Usuaria");

        doc.line(startL3, line, startL3 + linlong, line);
        doc.text(startL3 + 10, 285, "Mecánico o Especialista");

        doc.line(startL4, line, startL4 + linlong, line);
        doc.text(startL4 + 11, 285, "Registro SIME OCP");
      }

      // Pagina 2
      doc.addPage();
      doc.setFont("helvetica", "bold");
      doc.setFontSize(7);
      doc.text("GALERÍA DE IMÁGENES", pageWidth / 2, 25, { align: "center" });
      doc.text("CÓD. PATRIMONIAL: " + me.codbien, pageWidth / 2, 30, { align: "center" });

      var imgBien = "data:image/png;base64," + (me.imagen == null || me.imagen == '' ? me.imagenxdefec : me.imagen);
      var imgBien2 = "data:image/png;base64," + (me.imagen2 == null || me.imagen2 == '' ? me.imagenxdefec : me.imagen2);
      var imgBien3 = "data:image/png;base64," + (me.imagen3 == null || me.imagen3 == '' ? me.imagenxdefec : me.imagen3);
      // Fin Ubicacion Imagen

      var imgWidth = 120; // Ancho
      var imgHeight = 120; // Altura
      var imgWidth2 = 80; // Ancho
      var imgHeight2 = 80; // Altura
      var imgMargin = 10; // Margen entre las imágenes y los bordes de la página

      // Calcular la posición horizontal para las imágenes
      var startX1 = (pageWidth - imgWidth / 2 * 2) / 2;
      var startX2 = (pageWidth - imgWidth2 * 2 - imgMargin) / 2;
      var startX3 = startX2 + imgWidth2 + imgMargin;

      // Calcular la posición vertical para las imágenes
      var startY = 40;
      // Agregar las imágenes al documento con las nuevas posiciones
      doc.addImage(imgBien, "JPEG", startX1, startY, imgWidth, imgHeight);
      doc.addImage(imgBien2, "JPEG", startX2, startY + 130, imgWidth2, imgHeight2);
      doc.addImage(imgBien3, "JPEG", startX3, startY + 130, imgWidth2, imgHeight2);
      // Fin Ubicacion Imagen

      addHeaders(doc);

      // Exportar
      me.stringPdf = doc.output("datauristring");
      me.blobPdf = doc.output("blob");

      // Para visualizar todas las paginas del pdf
      this.srcPdf = pdf.createLoadingTask(this.stringPdf);
      this.srcPdf.promise.then((pdf) => {
        this.numPages = pdf.numPages;
      });
    }
    /* Crear PDF bien */
  },
};
</script>